(function () {
  if (window.__kartmaxSearchEmbedInitialized) {
    return;
  }

  window.__kartmaxSearchEmbedInitialized = true;

  // Capture while currentScript is available (theme asset base for skeleton PNGs).
  const KARTMAX_THEME_ASSET_BASE = (function () {
    const script = document.currentScript;
    const src = script && typeof script.src === "string" ? script.src : "";
    const idx = src.indexOf("/assets/");
    return idx === -1 ? "" : src.slice(0, idx + "/assets/".length);
  })();

  const DEFAULT_TRENDING_SEARCHES = [
    "New Arrivals",
    "Best Sellers",
    "Gift Cards",
    "Collections",
    "Featured",
    "Shop All",
  ];
  const ROOT_SELECTOR = "[data-kartmax-search-root]";
  const SEARCH_RESULTS_BLOCK_SELECTOR = "[data-kartmax-search-results]";
  const THEME_SEARCH_OVERRIDE_SELECTOR = "[data-kartmax-theme-search]";
  const SEARCH_HIDDEN_CLASS = "kartmax-search-hidden";

  // max time the PLP waits for the KM widget to write
  // its tracking ids to localStorage before the first plp-special request.
  const SEARCH_TRACKING_WAIT_MS = 800;

  // search-page ONLY boot loader (never home / other templates)
  function isKartmaxSearchPage() {
    const path = window.location.pathname.replace(/\/+$/, "") || "/";
    return path === "/search" || document.body?.classList?.contains("template-search");
  }

  function stripSearchTrackingFromBrowserUrl() {
    if (!isKartmaxSearchPage()) {
      return;
    }

    try {
      var url = new URL(window.location.href);
      var searchId = (url.searchParams.get("search_id") || "").trim();
      var sessionId = (url.searchParams.get("session_id") || "").trim();
      if (!searchId && !sessionId) {
        return;
      }

      // store the query the ids belong to, so a stale
      // search_id is never sent with a different query later in the session.
      window.sessionStorage.setItem(
        "kartmax:search-page-tracking",
        JSON.stringify({
          searchId: searchId,
          sessionId: sessionId,
          query: (url.searchParams.get("q") || "").trim(),
        }),
      );
      url.searchParams.delete("search_id");
      url.searchParams.delete("session_id");
      var next =
        url.pathname +
        (url.searchParams.toString() ? "?" + url.searchParams.toString() : "") +
        url.hash;
      window.history.replaceState(null, "", next);
    } catch (error) {
      // ignore
    }
  }

  // theme asset URL (shopify theme dev + published theme)
  function getThemeAssetUrl(fileName) {
    if (!fileName) {
      return "";
    }
    if (KARTMAX_THEME_ASSET_BASE) {
      return KARTMAX_THEME_ASSET_BASE + fileName;
    }
    const nodes = document.querySelectorAll(
      'link[href*="/assets/"], script[src*="/assets/"], img[src*="/assets/"]',
    );
    for (let i = 0; i < nodes.length; i += 1) {
      const href = nodes[i].href || nodes[i].src || "";
      const idx = href.indexOf("/assets/");
      if (idx === -1) {
        continue;
      }
      return href.slice(0, idx + "/assets/".length) + fileName;
    }
    // Local theme-dev fallback when script is injected without /assets/ src
    return "/" + fileName;
  }

  function buildSkeletonLoaderHtml(label) {
    const desktop = getThemeAssetUrl("kartmax-loader-search-desktop-skeleton.png");
    const mobile = getThemeAssetUrl("kartmax-loader-search-mobile-skeleton.png");
    const text = label || "Loading results…";
    return (
      '<div class="kartmax-skeleton-loader" data-kartmax-skeleton-loader>' +
      '  <picture>' +
      '    <source media="(max-width: 989px)" srcset="' +
      mobile +
      '">' +
      '    <img class="kartmax-skeleton-loader__img" src="' +
      desktop +
      '" alt="" width="1400" height="900" decoding="async">' +
      "  </picture>" +
      '  <span class="kartmax-search-visually-hidden">' +
      text +
      "</span>" +
      "</div>"
    );
  }

  if (isKartmaxSearchPage()) {
    stripSearchTrackingFromBrowserUrl();
    document.documentElement.classList.add("kartmax-search-page-loading");
    hideNativeSearchSection();
    mountSearchBootLoader();
    window.setTimeout(function () {
      if (!window.__kartmaxSearchPageReady) {
        revealKartmaxSearchPage();
      }
    }, 2000);
  }

  bootstrapKartmaxSearch();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrapKartmaxSearch, {
      once: true,
    });
  }

  function getSearchContentWrapper() {
    if (!isKartmaxSearchPage()) {
      return null;
    }
    return (
      document.querySelector("body.template-search #MainContent > .main-content__wrapper") ||
      document.querySelector("body.template-search .main-content__wrapper") ||
      null
    );
  }

  function hideNativeSearchSection() {
    if (!isKartmaxSearchPage()) {
      return;
    }
    function apply() {
      if (!isKartmaxSearchPage()) {
        return;
      }
      document
        .querySelectorAll(
          "body.template-search .main-content__wrapper .shopify-section[id*='__search'], body.template-search .shopify-section[id*='__search']"
        )
        .forEach(function (node) {
          node.classList.add(SEARCH_HIDDEN_CLASS);
          node.setAttribute("aria-hidden", "true");
          node.style.setProperty("display", "none", "important");
          node.style.setProperty("visibility", "hidden", "important");
        });
    }

    if (document.body) {
      apply();
    } else {
      document.addEventListener("DOMContentLoaded", apply, { once: true });
    }
  }

  function mountSearchBootLoader() {
    if (!isKartmaxSearchPage()) {
      return;
    }
    function inject() {
      if (!isKartmaxSearchPage()) {
        return;
      }
      // snippet kartmax-search-app already painted loader
      const existing =
        document.getElementById("kartmax-app-boot-loader") ||
        document.getElementById("kartmax-search-boot-loader");
      if (existing) {
        hideNativeSearchSection();
        return;
      }

      // Only inject into search wrapper — never fall back to home #MainContent/body.
      const wrapper = getSearchContentWrapper();
      if (!wrapper) {
        return;
      }

      hideNativeSearchSection();

      const loader = document.createElement("div");
      loader.id = "kartmax-search-boot-loader";
      loader.className = "kartmax-search-boot-loader";
      loader.setAttribute("role", "status");
      loader.setAttribute("aria-live", "polite");
      loader.setAttribute("aria-busy", "true");
      // #ddd skeleton images (desktop/mobile)
      loader.innerHTML = buildSkeletonLoaderHtml("Loading results…");

      wrapper.insertBefore(loader, wrapper.firstChild);
    }

    if (document.body) {
      inject();
    } else {
      document.addEventListener("DOMContentLoaded", inject, { once: true });
    }
  }

  function bootstrapKartmaxSearch() {
    // guard: body is null if the script runs from <head>,
    // which previously threw and aborted the whole embed.
    if (!document.body) {
      return;
    }

    document.body.classList.add("kartmax-search-loader-dismissed");

    // Boot loader / native hide are search-page only.
    if (isKartmaxSearchPage()) {
      hideNativeSearchSection();
      mountSearchBootLoader();
    }

    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      try {
        initializeKartmaxSearch(root);
      } catch (error) {
        console.error("KartmaX search embed failed to initialize.", error);
        if (isKartmaxSearchPage()) {
          revealKartmaxSearchPage();
        }
      }
    });
  }

  function revealKartmaxSearchPage() {
    if (!isKartmaxSearchPage()) {
      return;
    }
    if (window.__kartmaxSearchPageReady) {
      return;
    }
    window.__kartmaxSearchPageReady = true;

    hideNativeSearchSection();
    document.documentElement.classList.remove("kartmax-search-page-loading");
    document.documentElement.classList.add("kartmax-search-ready");
    if (document.body) {
      document.body.classList.add("kartmax-search-ready");
    }

    const bootLoader =
      document.getElementById("kartmax-app-boot-loader") ||
      document.getElementById("kartmax-search-boot-loader");
    if (bootLoader) {
      bootLoader.setAttribute("aria-busy", "false");
      bootLoader.classList.add("is-leaving");
      bootLoader.setAttribute("hidden", "hidden");
      window.setTimeout(function () {
        if (bootLoader.parentNode) {
          bootLoader.remove();
        }
      }, 240);
    }

    // After ready, hide the whole native wrapper (loader gone; Kartmax PLP shows).
    const wrapper = getSearchContentWrapper();
    if (wrapper) {
      wrapper.classList.add(SEARCH_HIDDEN_CLASS);
      wrapper.setAttribute("aria-hidden", "true");
      wrapper.style.setProperty("display", "none", "important");
    }
  }

  function isKmSearchWidgetActive() {
    return Boolean(
      document.getElementById("kartmax-search-host") ||
        document.querySelector("[data-kartmax-km-search-config]"),
    );
  }

  function removeLegacySearchLaunchers() {
    document
      .querySelectorAll(".kartmax-search-launcher, .kartmax-search-overlay")
      .forEach(function (element) {
        element.remove();
      });
  }

  function initializeKartmaxSearch(root) {
    if (root.dataset.kartmaxInitialized === "true") {
      return;
    }

    const configNode = root.querySelector("[data-kartmax-km-search-config]");
    if (!configNode || !configNode.textContent) {
      revealKartmaxSearchPage();
      return;
    }

    const config = normalizeConfig(JSON.parse(configNode.textContent));
    root.dataset.kartmaxInitialized = "true";
    initializeSearchPageResults(config);

    // KM CDN widget owns the header search input — do not inject the legacy launcher.
    if (isKmSearchWidgetActive()) {
      removeLegacySearchLaunchers();
      return;
    }

    const state = {
      abortController: null,
      debounceTimer: 0,
      query: config.defaultQuery || "*",
    };

    const ui = createOverlay(config);
    const launcher = createLauncher(config);
    document.body.appendChild(ui.overlay);
    bindOverlaySearch(ui, launcher, config, state);
    interceptThemeSearch(function (incomingQuery) {
      const launcherInput = launcher.querySelector(".kartmax-search-launcher__input");
      if (!launcherInput) {
        return;
      }

      openOverlay(
        ui,
        launcher,
        launcherInput,
        config,
        state,
        incomingQuery || config.defaultQuery || "*",
      );
      launcherInput.focus();
    });
    if (!mountLauncherIntoHeader(config, launcher)) {
      launcher.classList.add("kartmax-search-launcher--floating");
      document.body.appendChild(launcher);
      scheduleHeaderMountRetries(config, launcher);
      waitForHeaderMount(config, launcher);
    }
  }

  function normalizeConfig(rawConfig) {
    const config = rawConfig || {};

    return {
      apiUrl: config.searchApiUrl || config.apiUrl || "",
      defaultQuery: config.defaultQuery || "*",
      defaultSearchResultsSelector:
        config.defaultSearchResultsSelector ||
        ".template-search__header, .template-search__search, .template-search__results, .template-search__results-count, #product-grid, .search-results, .main-search__results, [data-search-results], .boost-sd__product-grid, .snize-search-results",
      defaultSearchSelector:
        config.defaultSearchSelector ||
        ".header__icon--search, .search-modal, .header__search, predictive-search, details-modal summary[aria-controls*='Search'], button[aria-controls*='Search'], a[href='/search'], a[href^='/search?'], button[aria-label*='search' i], a[aria-label*='search' i], summary[aria-label*='search' i]",
      emptyStateMessage:
        config.emptyStateMessage || "Start typing to search your catalog.",
      fallbackSearchPath: config.fallbackSearchPath || "/search",
      headerMountSelector: config.headerMountSelector || ".header__icons",
      hideDefaultSearch:
        typeof config.hideDefaultSearch === "boolean"
          ? config.hideDefaultSearch
          : true,
      launcherLabel: config.launcherLabel || "Search",
      noResultsMessage: config.noResultsMessage || "No matching products found.",
      replaceSearchPageResults:
        typeof config.replaceSearchPageResults === "boolean"
          ? config.replaceSearchPageResults
          : true,
      resultsLimit: Number(config.resultsLimit) || 8,
      searchPageResultsLimit: Number(config.searchPageResultsLimit) || 24,
      searchPageInsertPosition: config.searchPageInsertPosition || "afterbegin",
      searchPageMountSelector: normalizeSearchPageMountSelector(
        config.searchPageMountSelector,
      ),
      searchPlaceholder: config.searchPlaceholder || "Search products or brands..",
      shopName: String(config.shopName || "").trim(),
      ui: normalizeFacetedUi(config.ui || {}),
    };
  }

  // body.template-search is not a safe PLP mount.
  function normalizeSearchPageMountSelector(selectorText) {
    const safeSelector =
      "main#MainContent, #MainContent, main.main-content, .main-search, main";
    const selectors = String(selectorText || "")
      .split(",")
      .map(function (selector) {
        return selector.trim();
      })
      .filter(Boolean);

    if (
      !selectors.length ||
      selectors.some(function (selector) {
        return selector === ".template-search" || selector === "body";
      })
    ) {
      return safeSelector;
    }

    return selectors.join(", ");
  }

  const DEFAULT_SORT_OPTIONS = [
    { value: "", label: "Featured" },
    { value: "selling_price:asc", label: "Price, low to high" },
    { value: "selling_price:desc", label: "Price, high to low" },
    { value: "name:asc", label: "Alphabetically, A-Z" },
    { value: "name:desc", label: "Alphabetically, Z-A" },
  ];

  const TROLLEY_ICON_SVG =
    '<svg class="icon icon--trolley" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" aria-hidden="true">' +
    '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M6.6665 3.51997h2m0 0h2m-2 0V1.5m0 2.01997V5.5M1.49976 2h.924c.34 0 .63666.22867.72466.55667l.25534.958L4.99976 9.5m0 0h7.47864c.7474-1.53333 1.4-3.12267 1.9494-4.75867M4.99976 9.5c-.53044 0-1.03914.21071-1.41422.5858-.37507.3751-.58578.8838-.58578 1.4142H13.4998m-9.50004 2c0 .1326-.05268.2598-.14645.3536-.09377.0937-.22095.1464-.35355.1464-.13261 0-.25979-.0527-.35356-.1464-.09377-.0938-.14644-.221-.14644-.3536s.05267-.2598.14644-.3536c.09377-.0937.22095-.1464.35356-.1464.1326 0 .25978.0527.35355.1464.09377.0938.14645.221.14645.3536m7.64644.3536c-.0938-.0938-.1464-.221-.1464-.3536s.0526-.2598.1464-.3536c.0938-.0937.2209-.1464.3536-.1464.1326 0 .2597.0527.3535.1464.0938.0938.1465.221.1465.3536s-.0527.2598-.1465.3536c-.0938.0937-.2209.1464-.3535.1464-.1327 0-.2598-.0527-.3536-.1464"></path>' +
    "</svg>";

  // match theme Dirham icon (money-with-dirham).
  const DIRHAM_ICON_SVG =
    '<svg class="icon icon--dirham dirham-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 344.84 299.91" aria-hidden="true">' +
    '<path d="M342.14,140.96l2.7,2.54v-7.72c0-17-11.92-30.84-26.56-30.84h-23.41C278.49,36.7,222.69,0,139.68,0c-52.86,0-59.65,0-109.71,0,0,0,15.03,12.63,15.03,52.4v52.58h-27.68c-5.38,0-10.43-2.08-14.61-6.01l-2.7-2.54v7.72c0,17.01,11.92,30.84,26.56,30.84h18.44s0,29.99,0,29.99h-27.68c-5.38,0-10.43-2.07-14.61-6.01l-2.7-2.54v7.71c0,17,11.92,30.82,26.56,30.82h18.44s0,54.89,0,54.89c0,38.65-15.03,50.06-15.03,50.06h109.71c85.62,0,139.64-36.96,155.38-104.98h32.46c5.38,0,10.43,2.07,14.61,6l2.7,2.54v-7.71c0-17-11.92-30.83-26.56-30.83h-18.9c.32-4.88.49-9.87.49-15s-.18-10.11-.51-14.99h28.17c5.37,0,10.43,2.07,14.61,6.01ZM89.96,15.01h45.86c61.7,0,97.44,27.33,108.1,89.94l-153.96.02V15.01ZM136.21,284.93h-46.26v-89.98l153.87-.02c-9.97,56.66-42.07,88.38-107.61,90ZM247.34,149.96c0,5.13-.11,10.13-.34,14.99l-157.04.02v-29.99l157.05-.02c.22,4.84.33,9.83.33,15Z"></path>' +
    "</svg>";

  function normalizeFacetedUi(ui) {
    return {
      accentColor: ui.accentColor || "#0053a3",
      applyFiltersLabel: ui.applyFiltersLabel || "Apply The Filters",
      clearFiltersLabel: ui.clearFiltersLabel || "Clear",
      drawerTitle: ui.drawerTitle || "Sort & Filter",
      drawerWidth: ui.drawerWidth || "40rem",
      filterButtonLabel: ui.filterButtonLabel || "Sort & Filter",
      showFilterButton: ui.showFilterButton !== false,
      sortByLabel: ui.sortByLabel || "Sort By",
    };
  }

  function createLauncher(config) {
    const form = document.createElement("form");
    form.className = "kartmax-search-launcher";
    form.setAttribute("role", "search");
    form.setAttribute("aria-label", config.launcherLabel || "Search");
    form.innerHTML =
      '<button class="kartmax-search-launcher__icon" type="button" aria-label="' +
      escapeAttribute(config.launcherLabel || "Search") +
      '">' +
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="5.75" stroke="currentColor" stroke-width="1.5"></circle><path d="M13.5 13.5L17 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>' +
      "</button>" +
      '<input class="kartmax-search-launcher__input" type="search" autocomplete="off" placeholder="' +
      escapeAttribute(config.searchPlaceholder || "Search products or brands..") +
      '" aria-label="' +
      escapeAttribute(config.searchPlaceholder || "Search products or brands..") +
      '">' +
      '<button class="kartmax-search-launcher__submit kartmax-search-visually-hidden" type="submit">' +
      escapeHtml(config.launcherLabel || "Search") +
      "</button>";
    return form;
  }

  function createOverlay(config) {
    const overlay = document.createElement("div");
    overlay.className = "kartmax-search-overlay";
    overlay.hidden = true;
    overlay.innerHTML =
      '<div class="kartmax-search-overlay__backdrop"></div>' +
      '<div class="kartmax-search-panel" role="dialog" aria-modal="true" aria-label="Site search">' +
      '  <div class="kartmax-search-panel__body">' +
      '    <section class="kartmax-search-section">' +
      '      <div class="kartmax-search-section__header">' +
      '        <h2 class="kartmax-search-section__title">Trending searches</h2>' +
      "      </div>" +
      '      <div class="kartmax-search-trends"></div>' +
      "    </section>" +
      '    <section class="kartmax-search-section">' +
      '      <div class="kartmax-search-section__header">' +
      '        <h2 class="kartmax-search-section__title">Featured brands</h2>' +
      "      </div>" +
      '      <div class="kartmax-search-brands"></div>' +
      "    </section>" +
      '    <section class="kartmax-search-section kartmax-search-section--results">' +
      '      <div class="kartmax-search-results-head">' +
      '        <div class="kartmax-search-results-copy">' +
      '          <h2 class="kartmax-search-results-title">Best Sellers</h2>' +
      '          <p class="kartmax-search-panel__status">' +
      escapeHtml(config.emptyStateMessage || "Start typing to search your catalog.") +
      "</p>" +
      "        </div>" +
      '        <div class="kartmax-search-results-actions">' +
      '          <a class="kartmax-search-panel__link" href="#">Search store</a>' +
      '          <div class="kartmax-search-results-nav">' +
      '            <button class="kartmax-search-results-nav__button" type="button" aria-label="Previous products">&larr;</button>' +
      '            <button class="kartmax-search-results-nav__button" type="button" aria-label="Next products">&rarr;</button>' +
      "          </div>" +
      "        </div>" +
      "      </div>" +
      '    <div class="kartmax-search-grid"></div>' +
      "    </section>" +
      "  </div>" +
      "</div>";

    return {
      backdrop: overlay.querySelector(".kartmax-search-overlay__backdrop"),
      brandRail: overlay.querySelector(".kartmax-search-brands"),
      fallbackLink: overlay.querySelector(".kartmax-search-panel__link"),
      grid: overlay.querySelector(".kartmax-search-grid"),
      nextButton: overlay.querySelectorAll(".kartmax-search-results-nav__button")[1],
      overlay: overlay,
      panel: overlay.querySelector(".kartmax-search-panel"),
      previousButton: overlay.querySelectorAll(".kartmax-search-results-nav__button")[0],
      status: overlay.querySelector(".kartmax-search-panel__status"),
      trendRail: overlay.querySelector(".kartmax-search-trends"),
    };
  }

  function bindOverlaySearch(ui, launcher, config, state) {
    const launcherInput = launcher.querySelector(".kartmax-search-launcher__input");
    const launcherIcon = launcher.querySelector(".kartmax-search-launcher__icon");

    if (!launcherInput || !launcherIcon) {
      return;
    }

    function openLauncherOverlay(query) {
      openOverlay(
        ui,
        launcher,
        launcherInput,
        config,
        state,
        query || launcherInput.value.trim() || state.query || config.defaultQuery || "*",
      );
    }

    function navigateFromOverlay(query) {
      closeOverlay(ui, launcher);
      navigateToSearchPage(config, query);
    }

    function bindDirectOverlayNavigation() {
      ui.trendRail
        .querySelectorAll(".kartmax-search-chip")
        .forEach(function (chip) {
          if (chip.dataset.kartmaxBound === "true") {
            return;
          }

          chip.dataset.kartmaxBound = "true";
          chip.addEventListener("click", function (event) {
            event.preventDefault();
            navigateFromOverlay(chip.dataset.query || chip.textContent || "");
          });
        });

      if (ui.fallbackLink && ui.fallbackLink.dataset.kartmaxBound !== "true") {
        ui.fallbackLink.dataset.kartmaxBound = "true";
        ui.fallbackLink.addEventListener("click", function (event) {
          event.preventDefault();
          navigateFromOverlay(launcherInput.value.trim() || state.query || "");
        });
      }
    }

    launcher.addEventListener("click", function (event) {
      if (event.target === launcherInput) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      openLauncherOverlay();
    });

    launcherIcon.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      openLauncherOverlay();
      launcherInput.focus();
    });

    launcherInput.addEventListener("click", function () {
      openLauncherOverlay();
    });

    launcherInput.addEventListener("focus", function () {
      openLauncherOverlay();
    });

    ui.backdrop.addEventListener("click", function () {
      closeOverlay(ui, launcher);
    });

    document.addEventListener("pointerdown", function (event) {
      if (
        ui.overlay.hidden ||
        !(event.target instanceof Node) ||
        !ui.panel ||
        ui.panel.contains(event.target) ||
        launcher.contains(event.target)
      ) {
        return;
      }

      closeOverlay(ui, launcher);
    });

    launcherInput.addEventListener("input", function (event) {
      const nextQuery = event.target.value.trim();

      if (ui.overlay.hidden) {
        openLauncherOverlay(nextQuery || config.defaultQuery || "*");
      }

      window.clearTimeout(state.debounceTimer);
      state.debounceTimer = window.setTimeout(function () {
        runSearch(ui, config, state, nextQuery || config.defaultQuery || "*");
      }, 220);
    });

    launcherInput.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      navigateFromOverlay(launcherInput.value.trim() || state.query || "");
    });

    launcher.addEventListener("submit", function (event) {
      event.preventDefault();
      navigateFromOverlay(launcherInput.value.trim() || state.query || "");
    });

    ui.overlay.addEventListener("click", function (event) {
      const target = event.target instanceof Element ? event.target.closest("a") : null;
      if (!target) {
        return;
      }

      if (target.classList.contains("kartmax-search-chip")) {
        event.preventDefault();
        navigateFromOverlay(target.dataset.query || target.textContent || "");
        return;
      }

      if (target.classList.contains("kartmax-search-panel__link")) {
        event.preventDefault();
        navigateFromOverlay(launcherInput.value.trim() || state.query || "");
      }
    });

    bindDirectOverlayNavigation();

    if (ui.previousButton && ui.nextButton) {
      ui.previousButton.addEventListener("click", function () {
        ui.grid.scrollBy({
          left: -Math.max(ui.grid.clientWidth * 0.72, 260),
          behavior: "smooth",
        });
      });

      ui.nextButton.addEventListener("click", function () {
        ui.grid.scrollBy({
          left: Math.max(ui.grid.clientWidth * 0.72, 260),
          behavior: "smooth",
        });
      });
    }

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !ui.overlay.hidden) {
        closeOverlay(ui, launcher);
      }
    });
  }

  function hideDefaultSearch(selectorText, preservedNode) {
    if (!selectorText) {
      return;
    }

    getMatchingNodes(selectorText).forEach(function (node) {
      if (
        preservedNode &&
        node instanceof Element &&
        (node === preservedNode || node.contains(preservedNode))
      ) {
        return;
      }

      const host = getSearchTriggerHost(node);
      if (
        preservedNode &&
        host instanceof Element &&
        (host === preservedNode || host.contains(preservedNode))
      ) {
        return;
      }

      host.classList.add(SEARCH_HIDDEN_CLASS);
      host.setAttribute("aria-hidden", "true");
    });
  }

  function hideDefaultSearchResults(selectorText, preservedNode) {
    if (!selectorText) {
      return;
    }

    selectorText
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean)
      .forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (node) {
          if (node.closest(".kartmax-search-page")) {
            return;
          }

          if (
            preservedNode &&
            node instanceof Element &&
            (node === preservedNode || node.contains(preservedNode))
          ) {
            return;
          }

          node.classList.add(SEARCH_HIDDEN_CLASS);
          node.setAttribute("aria-hidden", "true");
        });
      });
  }

  // CW keeps native search sections inside this wrapper; hide it before mounting our PLP.
  function hideLegacySearchContentWrapper(preservedNode) {
    document.querySelectorAll(".main-content__wrapper").forEach(function (node) {
      if (
        node.closest(".kartmax-search-page") ||
        node.querySelector(".kartmax-search-page") ||
        (preservedNode &&
          (node === preservedNode ||
            node.contains(preservedNode) ||
            preservedNode.contains(node)))
      ) {
        return;
      }

      node.classList.add(SEARCH_HIDDEN_CLASS);
      node.setAttribute("aria-hidden", "true");
    });
  }

  // The CW theme can re-render its native search wrapper after the PLP mounts.
  function observeLegacySearchContentWrapper(mountTarget) {
    if (
      !(mountTarget instanceof Element) ||
      mountTarget.dataset.kartmaxLegacySearchObserver === "true"
    ) {
      return;
    }

    mountTarget.dataset.kartmaxLegacySearchObserver = "true";
    let isScheduled = false;
    const observer = new MutationObserver(function () {
      if (isScheduled) {
        return;
      }

      isScheduled = true;
      window.requestAnimationFrame(function () {
        hideLegacySearchContentWrapper();
        isScheduled = false;
      });
    });

    observer.observe(mountTarget, { childList: true, subtree: true });
  }

  function hideMountTargetSiblings(existingChildren) {
    existingChildren.forEach(function (node) {
      if (!(node instanceof Element)) {
        return;
      }

      // preserve chrome; hide native results only.
      if (
        node.matches("site-header-wrapper, header, .site-header, #shopify-section-header") ||
        node.querySelector("site-header-wrapper, header, .site-header, #shopify-section-header")
      ) {
        node.classList.remove(SEARCH_HIDDEN_CLASS);
        node.removeAttribute("aria-hidden");
        return;
      }

      if (
        node.matches(".main-content__wrapper, .template-search__results, .search-results") ||
        node.querySelector(".main-content__wrapper, .template-search__results, .search-results")
      ) {
        node.classList.add(SEARCH_HIDDEN_CLASS);
        node.setAttribute("aria-hidden", "true");
      }
    });
  }

  function restoreGlobalPageChrome() {
    document.querySelectorAll("main#MainContent, footer").forEach(function (node) {
      node.classList.remove(SEARCH_HIDDEN_CLASS);
      node.removeAttribute("aria-hidden");
    });
  }

  function hideKartmaxSearchResultsBlocks(preservedNode) {
    document.querySelectorAll(SEARCH_RESULTS_BLOCK_SELECTOR).forEach(function (node) {
      if (
        preservedNode &&
        node instanceof Element &&
        (node === preservedNode || node.contains(preservedNode) || preservedNode.contains(node))
      ) {
        return;
      }

      node.classList.add(SEARCH_HIDDEN_CLASS);
      node.setAttribute("aria-hidden", "true");
    });
  }

  function formatResultsSummary(total, shown, page, totalPages) {
    const totalCount = Number(total) || 0;
    const shownCount = Number(shown) || 0;
    const currentPage = Number(page) || 1;
    const pages = Number(totalPages) || 1;
    const pageSuffix = pages > 1 ? " · Page " + currentPage + " of " + pages : "";

    if (totalCount > shownCount) {
      return "Showing " + shownCount + " of " + totalCount + " products" + pageSuffix;
    }

    if (totalCount === 1) {
      return "1 product found" + pageSuffix;
    }

    return totalCount + " products found" + pageSuffix;
  }

  function renderSearchLoadMore(node, state, totalPages, shownProducts, total, onChange) {
    if (!node || totalPages <= 1) {
      if (node) {
        node.innerHTML = "";
      }
      return;
    }

    const currentPage = state.page || 1;
    const progress = total > 0 ? Math.min(100, (shownProducts / total) * 100) : 0;
    const buttonHtml = currentPage < totalPages
      ? '<button type="button" class="kartmax-search-page__page-btn" data-page="' +
        (currentPage + 1) +
        '">Load More</button>'
      : "";

    node.innerHTML =
      '<span class="kartmax-search-page__page-label">Showing ' +
      shownProducts +
      " of " +
      total +
      "</span>" +
      '<span class="kartmax-search-page__progress" aria-hidden="true">' +
      '<span class="kartmax-search-page__progress-value" style="width: ' +
      progress.toFixed(2) +
      '%"></span></span>' +
      buttonHtml;

    const button = node.querySelector("[data-page]");
    if (button) {
      button.addEventListener("click", function () {
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        button.textContent = "Loading…";
        onChange(Number(button.getAttribute("data-page") || "1"));
      });
    }
  }

  // scroll PLP to top (clear of sticky header)
  function scrollToSearchResults(container) {
    if (!container || typeof window.scrollTo !== "function") {
      return;
    }

    const target =
      container.querySelector("[data-kartmax-query-banner]") ||
      container.querySelector(".kartmax-search-page__main") ||
      container;
    const wrap = document.querySelector("site-header-wrapper, .site-header-wrapper");
    const headerOffset = wrap ? wrap.getBoundingClientRect().height : 0;
    const top =
      target.getBoundingClientRect().top +
      (window.pageYOffset || document.documentElement.scrollTop || 0) -
      headerOffset -
      12;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: "smooth",
    });
  }

  function sliceSearchProducts(products, limit) {
    const max = Number(limit) || products.length || 0;
    return products.slice(0, Math.max(max, 0));
  }

  function replaceHeaderSearchTrigger(target, nativeSearchTarget, replacementNode) {
    if (
      nativeSearchTarget &&
      nativeSearchTarget.parentElement &&
      target.contains(nativeSearchTarget)
    ) {
      nativeSearchTarget.replaceWith(replacementNode);
      return;
    }

    target.appendChild(replacementNode);
  }

  function mountLauncherIntoHeader(config, launcher) {
    const target = document.querySelector(config.headerMountSelector);
    if (!target) {
      return false;
    }

    const nativeSearchTarget = findHeaderSearchReplacementTarget(
      config.defaultSearchSelector,
      target,
    );

    launcher.classList.remove("kartmax-search-launcher--floating");
    replaceHeaderSearchTrigger(target, nativeSearchTarget, launcher);

    if (config.hideDefaultSearch) {
      hideDefaultSearch(config.defaultSearchSelector, launcher);
    }

    return true;
  }

  function waitForHeaderMount(config, launcher) {
    if (!document.body) {
      return;
    }

    const observer = new MutationObserver(function () {
      if (mountLauncherIntoHeader(config, launcher)) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function scheduleHeaderMountRetries(config, launcher) {
    [150, 500, 1200, 2400].forEach(function (delay) {
      window.setTimeout(function () {
        mountLauncherIntoHeader(config, launcher);
      }, delay);
    });
  }

  function findHeaderSearchReplacementTarget(selectorText, headerTarget) {
    const candidates = getMatchingNodes(selectorText);

    for (const node of candidates) {
      const host = getSearchTriggerHost(node);
      if (headerTarget.contains(host)) {
        return host;
      }
    }

    return null;
  }

  function getSearchTriggerHost(node) {
    if (!(node instanceof Element)) {
      return node;
    }

    return (
      node.closest("details-modal, details, predictive-search, .search-modal") ||
      node.closest(".header__search, .header__icon, .header__icons") ||
      node.closest("summary, button, a") ||
      node
    );
  }

  function getMatchingNodes(selectorText) {
    if (!selectorText) {
      return [];
    }

    const nodes = [];

    selectorText
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean)
      .forEach(function (selector) {
        document.querySelectorAll(selector).forEach(function (node) {
          nodes.push(node);
        });
      });

    return nodes;
  }

  function interceptThemeSearch(onSearch) {
    if (window.__kartmaxSearchInterceptBound) {
      return;
    }

    window.__kartmaxSearchInterceptBound = true;

    document.addEventListener("submit", function (event) {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      const action = form.getAttribute("action") || "";
      if (!action.includes("/search")) {
        return;
      }

      const formData = new FormData(form);
      const query = String(formData.get("q") || "").trim();
      event.preventDefault();
      event.stopPropagation();
      navigateToSearchPage(getSearchConfig(), query);
    }, true);

    document.addEventListener("click", function (event) {
      if (!onSearch) {
        return;
      }

      const trigger = event.target instanceof Element
        ? event.target.closest(
            '.header__icon--search, summary[aria-controls*="Search"], button[aria-controls*="Search"], a[href="/search"], a[href^="/search?"]',
          )
        : null;

      if (!trigger) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === "function") {
        event.stopImmediatePropagation();
      }
      onSearch("");
    }, true);
  }

  function openOverlay(ui, launcher, launcherInput, config, state, initialQuery) {
    ui.overlay.hidden = false;
    launcher.classList.add("kartmax-search-launcher--active");
    document.body.style.overflow = "hidden";
    launcherInput.value = initialQuery === "*" ? "" : initialQuery;
    runSearch(ui, config, state, initialQuery);
  }

  function closeOverlay(ui, launcher) {
    ui.overlay.hidden = true;
    if (launcher) {
      launcher.classList.remove("kartmax-search-launcher--active");
    }
    document.body.style.overflow = "";
  }

  function runSearch(ui, config, state, rawQuery) {
    const query = rawQuery || config.defaultQuery || "*";
    state.query = query;

    if (state.abortController) {
      state.abortController.abort();
    }

    const controller = new AbortController();
    state.abortController = controller;

    ui.status.textContent = query === "*"
      ? "Showing featured search results."
      : 'Searching for "' + query + '"...';
    ui.grid.innerHTML = "";
    renderOverlayRails(ui, query, []);
    updateFallbackLink(ui.fallbackLink, config.fallbackSearchPath, query);

    const searchUrl = buildSearchUrl(config.apiUrl, query, config.resultsLimit);
    if (!searchUrl) {
      ui.status.textContent =
        "KartmaX is not configured. Save KartmaX settings in the app admin.";
      return;
    }

    fetch(searchUrl, {
      signal: controller.signal,
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Search request failed.");
        }

        return response.json();
      })
      .then(function (payload) {
        const products = sliceSearchProducts(
          ((payload || {}).result || {}).products || [],
          config.resultsLimit,
        );
        const total = Number((payload || {}).totalHits || products.length || 0);
        // Chip clicks are handled by the overlay's delegated click listener.
        renderOverlayRails(ui, query, products);
        renderProducts(ui, config, query, products, total);
      })
      .catch(function (error) {
        if (error.name === "AbortError") {
          return;
        }

        renderOverlayRails(ui, query, []);
        ui.status.textContent =
          "KartmaX search is temporarily unavailable. You can continue with the store search link.";
      });
  }

  function renderOverlayRails(ui, query, products) {
    if (ui.trendRail) {
      ui.trendRail.innerHTML = getTrendingSearches(query, products)
        .map(function (label) {
          const trendHref = buildSearchPageHref(
            getSearchPagePath(),
            label,
          );
          return (
            '<a class="kartmax-search-chip" href="' +
            escapeAttribute(trendHref) +
            '" data-query="' +
            escapeAttribute(label) +
            '">' +
            "<span>" +
            escapeHtml(label) +
            "</span>" +
            '<span class="kartmax-search-chip__arrow" aria-hidden="true">&nearr;</span>' +
            "</a>"
          );
        })
        .join("");
    }

    if (ui.brandRail) {
      ui.brandRail.innerHTML = getFeaturedBrands(products)
        .map(function (brand) {
          return (
            '<div class="kartmax-search-brand-card">' +
            '<span class="kartmax-search-brand-card__wordmark">' +
            escapeHtml(brand) +
            "</span>" +
            "</div>"
          );
        })
        .join("");
    }
  }

  function renderProducts(ui, config, query, products, total) {
    if (!products.length) {
      ui.status.textContent = config.noResultsMessage || "No matching products found.";
      ui.grid.innerHTML =
        '<div class="kartmax-search-empty-state">' +
        escapeHtml(config.noResultsMessage || "No matching products found.") +
        "</div>";
      return;
    }

    ui.status.textContent =
      (query === "*"
        ? "Showing "
        : 'Showing results for "' + query + '" - ') +
      formatResultsSummary(total, products.length).toLowerCase();

    ui.grid.innerHTML = products
      .map(function (product) {
        const image = product.image
          ? '<img class="kartmax-search-card__image" src="' +
            escapeAttribute(product.image) +
            '" alt="' +
            escapeAttribute(product.name || "Product image") +
            '" loading="lazy">'
          : '<div class="kartmax-search-card__image kartmax-search-card__image--placeholder">No image</div>';
        const category = Array.isArray(product._category) && product._category.length
          ? '<p class="kartmax-search-card__category">' +
            escapeHtml(product._category.join(", ")) +
            "</p>"
          : "";

        return (
          '<a class="kartmax-search-card" href="' +
          escapeAttribute(productHref(product)) +
          '">' +
          image +
          '<div class="kartmax-search-card__content">' +
          '<p class="kartmax-search-card__brand">' +
          escapeHtml(product.brand || "KartmaX result") +
          "</p>" +
          '<h3 class="kartmax-search-card__title">' +
          escapeHtml(product.name || "Untitled product") +
          "</h3>" +
          category +
          '<p class="kartmax-search-card__price">' +
          formatPrice(product.price) +
          "</p>" +
          "</div>" +
          "</a>"
        );
      })
      .join("");
  }

  function getTrendingSearches(query, products) {
    const collected = [];

    if (query && query !== "*") {
      collected.push(query);
    }

    products.forEach(function (product) {
      if (Array.isArray(product._category)) {
        collected.push.apply(collected, product._category);
      }
    });

    return uniqueTrimmedValues(collected.concat(DEFAULT_TRENDING_SEARCHES))
      .map(limitLabelLength)
      .slice(0, 6);
  }

  function getFeaturedBrands(products) {
    const brands = uniqueTrimmedValues(
      products.map(function (product) {
        return product.brand;
      }),
    );

    if (brands.length > 0) {
      return brands.slice(0, 4).map(limitLabelLength);
    }

    return ["KartmaX", "Featured", "Collection", "Best Seller"];
  }

  function uniqueTrimmedValues(values) {
    return Array.from(
      new Set(
        values
          .map(function (value) {
            return typeof value === "string" ? value.trim() : "";
          })
          .filter(Boolean),
      ),
    );
  }

  function limitLabelLength(value) {
    return value.length > 22 ? value.slice(0, 21) + "…" : value;
  }

  function initializeSearchPageResults(config) {
    if (!config.replaceSearchPageResults) {
      return;
    }

    const currentPath = window.location.pathname.replace(/\/+$/, "") || "/";
    const searchPath = (config.fallbackSearchPath || "/search").replace(/\/+$/, "") || "/";
    const url = new URL(window.location.href);
    const query = (url.searchParams.get("q") || "").trim() || config.defaultQuery || "*";

    if (currentPath !== searchPath) {
      return;
    }

    const themeSearchOverride = document.querySelector(
      THEME_SEARCH_OVERRIDE_SELECTOR,
    );
    const dedicatedResultsBlock = document.querySelector(
      SEARCH_RESULTS_BLOCK_SELECTOR,
    );
    const preservedResultsRoot = themeSearchOverride || dedicatedResultsBlock;

    if (preservedResultsRoot) {
      hideDefaultSearchResults(
        config.defaultSearchResultsSelector,
        preservedResultsRoot,
      );
      return;
    }

    const mountTarget = resolveSearchPageMountTarget(config);
    const existingContainer = document.querySelector(".kartmax-search-page");
    if (existingContainer) {
      restoreGlobalPageChrome();
      if (mountTarget && existingContainer.parentElement !== mountTarget) {
        mountSearchPageContainer(
          mountTarget,
          existingContainer,
          config.searchPageInsertPosition,
        );
      }
      hideLegacySearchContentWrapper(existingContainer);
      hideDefaultSearchResults(config.defaultSearchResultsSelector, existingContainer);
      return;
    }

    if (!mountTarget) {
      return;
    }

    restoreGlobalPageChrome();
    hideLegacySearchContentWrapper();

    const container = document.createElement("section");
    container.className = "kartmax-search-page";
    applyFacetedUiTheme(container, config.ui);
    // hide duplicate search form; show query banner.
    container.innerHTML =
      '<div class="kartmax-search-page__query-banner" data-kartmax-query-banner>' +
      '  <h1 class="kartmax-search-page__query-title" data-kartmax-query-title>' +
      escapeHtml(buildSearchQueryHeading(query)) +
      "</h1>" +
      '  <p class="kartmax-search-page__query-count" data-kartmax-query-count>Loading results…</p>' +
      "</div>" +
      '<form class="kartmax-search-page__form" hidden aria-hidden="true">' +
      '  <input class="kartmax-search-page__input" type="search" name="q" autocomplete="off" value="' +
      escapeAttribute(query === "*" ? "" : query) +
      '" tabindex="-1">' +
      "</form>" +
      '<div class="kartmax-search-page__desktop-toolbar" data-kartmax-desktop-toolbar hidden></div>' +
      '<div class="kartmax-search-page__mobile-bar" data-kartmax-mobile-bar hidden></div>' +
      '<div class="kartmax-search-page__layout">' +
      '  <aside class="kartmax-search-page__sidebar" data-kartmax-filters-sidebar aria-label="Filter and sort" aria-hidden="true">' +
      '    <div class="kartmax-search-page__sidebar-inner">' +
      '      <h2 class="kartmax-search-page__sidebar-title" data-kartmax-drawer-title>Sort &amp; Filter</h2>' +
      '      <div class="kartmax-search-page__sidebar-header">' +
      '        <h2 class="kartmax-search-page__sidebar-mobile-title">Sort &amp; Filter</h2>' +
      '        <button type="button" class="kartmax-search-page__sidebar-close" data-kartmax-filters-close aria-label="Close filters">&times;</button>' +
      "      </div>" +
      '      <div class="kartmax-search-page__sidebar-sort" data-kartmax-sidebar-sort></div>' +
      '      <div class="kartmax-search-page__sidebar-facets" data-kartmax-sidebar-filters></div>' +
      '      <div class="kartmax-search-page__sidebar-footer">' +
      '        <button type="button" class="kartmax-search-page__filter-apply" data-kartmax-filter-apply>Apply The Filters</button>' +
      '        <button type="button" class="kartmax-search-page__filter-clear" data-kartmax-filter-clear hidden>Clear All Filters</button>' +
      "      </div>" +
      "    </div>" +
      "  </aside>" +
      '  <div class="kartmax-search-page__main">' +
      '    <p class="kartmax-search-page__summary" data-kartmax-summary hidden></p>' +
      '    <div class="kartmax-search-page__loader" data-kartmax-loader role="status" aria-live="polite">' +
      buildSkeletonLoaderHtml("Loading results…") +
      "    </div>" +
      '    <div class="kartmax-search-page__grid" data-kartmax-grid></div>' +
      '    <nav class="kartmax-search-page__pagination" data-kartmax-pagination aria-label="Search pagination"></nav>' +
      "  </div>" +
      "</div>" +
      '<button type="button" class="kartmax-search-page__mobile-backdrop" data-kartmax-filters-backdrop hidden aria-label="Close filters"></button>';

    const mountTargetExistingChildren = Array.from(mountTarget.children);

    mountSearchPageContainer(mountTarget, container, config.searchPageInsertPosition);
    hideMountTargetSiblings(mountTargetExistingChildren);
    hideKartmaxSearchResultsBlocks(container);
    hideDefaultSearchResults(config.defaultSearchResultsSelector, container);
    observeLegacySearchContentWrapper(mountTarget);
    bindFiltersChrome(config, container);

    const state = {
      activeFilters: [],
      page: 1,
      sortBy: "",
      sortDir: "desc",
    };
    const runtime = {
      expandedFacetKey: "",
      apiFilters: [],
      apiSortOptions: [],
      facetFilters: [],
      pending: createFacetedPending(state),
    };

    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    if (sidebar && window.matchMedia("(min-width: 990px)").matches) {
      sidebar.setAttribute("aria-hidden", "false");
    }

    // the KM widget can write its query/session ids to
    // localStorage after this script boots on /search. Wait briefly (capped well
    // inside the 2s reveal fail-safe) so the first plp-special call carries them.
    waitForSearchTracking(query, SEARCH_TRACKING_WAIT_MS).then(function () {
      updateSearchPageResults(container, config, query, state, runtime);
    });
  }

  function buildSearchQueryHeading(query) {
    if (!query || query === "*") {
      return "Here is what we found";
    }
    return 'Here is what we found for "' + query + '"';
  }

  function formatQueryResultCount(total) {
    const totalCount = Number(total) || 0;
    if (totalCount === 1) {
      return "Showing 1 result";
    }
    return "Showing " + totalCount + " results";
  }

  function resolveShopName(config) {
    const fromConfig = String((config && config.shopName) || "").trim();
    if (fromConfig) {
      return fromConfig;
    }

    const title = document.title || "";
    const match = title.match(/\s[–—-]\s+(.+)$/);
    return match && match[1] ? match[1].trim() : "";
  }

  function buildSearchPageDocumentTitle(query, total, shopName) {
    const count = Number(total) || 0;
    const resultWord = count === 1 ? "result" : "results";
    const normalizedQuery =
      query && String(query).trim() && query !== "*" ? String(query).trim() : "";
    let title = "Search: " + count + " " + resultWord;

    if (normalizedQuery) {
      title += ' found for "' + normalizedQuery + '"';
    }

    const storeName = String(shopName || "").trim();
    if (storeName) {
      title += " – " + storeName;
    }

    return title;
  }

  function updateSearchPageResults(container, config, query, state, runtime, options) {
    const summaryNode = container.querySelector("[data-kartmax-summary]");
    const queryTitleNode = container.querySelector("[data-kartmax-query-title]");
    const queryCountNode = container.querySelector("[data-kartmax-query-count]");
    const gridNode = container.querySelector("[data-kartmax-grid]");
    const paginationNode = container.querySelector("[data-kartmax-pagination]");
    const formNode = container.querySelector(".kartmax-search-page__form");
    const loaderNode = container.querySelector("[data-kartmax-loader]");
    const appendProducts = Boolean(options && options.appendProducts);
    const requestId = (runtime.requestId || 0) + 1;
    runtime.requestId = requestId;

    if (!gridNode || !state || !runtime) {
      return;
    }

    if (formNode) {
      formNode.hidden = true;
      formNode.setAttribute("aria-hidden", "true");
    }

    if (queryTitleNode) {
      queryTitleNode.textContent = buildSearchQueryHeading(query);
    }
    if (queryCountNode && !appendProducts) {
      queryCountNode.textContent = "Loading results…";
    }
    if (summaryNode) {
      summaryNode.hidden = true;
      summaryNode.textContent = "";
    }

    if (!appendProducts) {
      gridNode.innerHTML = "";
      if (paginationNode) {
        paginationNode.innerHTML = "";
      }
      if (loaderNode) {
        loaderNode.hidden = false;
      }
    }

    // tracking ids are attached here only (plp-special
    // call), validated against the current query.
    const searchUrl = appendSearchPageTrackingParams(
      buildSearchUrl(
        config.apiUrl,
        query,
        config.searchPageResultsLimit,
        state,
      ),
      readSearchTrackingParams(query),
    );
    function setQueryCount(text) {
      if (queryCountNode) {
        queryCountNode.textContent = text;
      }
    }

    function setSearchPageDocumentTitle(total) {
      if (appendProducts) {
        return;
      }

      document.title = buildSearchPageDocumentTitle(
        query,
        total,
        resolveShopName(config),
      );
    }

    if (!searchUrl) {
      setQueryCount("KartmaX is not configured.");
      gridNode.innerHTML =
        '<p class="kartmax-search-page__empty">KartmaX is not configured. Save KartmaX settings in the app admin.</p>';
      if (loaderNode) {
        loaderNode.hidden = true;
      }
      revealKartmaxSearchPage();
      return;
    }

    fetch(searchUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Search request failed.");
        }

        return response.json();
      })
      .then(function (payload) {
        if (requestId !== runtime.requestId) {
          return;
        }

        const products = sliceSearchProducts(
          ((payload || {}).result || {}).products || [],
          config.searchPageResultsLimit,
        );
        const total = Number(
          (payload || {}).result?.count ||
            (payload || {}).totalHits ||
            products.length ||
            0,
        );
        const pageSize = config.searchPageResultsLimit || 24;
        const totalPages = Math.max(1, Math.ceil(total / pageSize));
        const responseApiFilters = ((payload || {}).result || {}).filters || [];
        const responseFacetFilters = getFacetFilters(responseApiFilters);
        if (responseFacetFilters.length) {
          runtime.apiFilters = responseApiFilters;
          runtime.facetFilters = mergeFacetFilters(
            runtime.facetFilters,
            responseFacetFilters,
            state.activeFilters,
            total,
          );
        }
        const facetFilters = runtime.facetFilters || [];

        // dynamic sort comes back as a *top-level*
        // `result.sort` array (e.g. [{code, label, dir}]), not embedded inside
        // `result.filters`. Keep the last non-empty list across pages/queries,
        // since some responses can omit it the same way facet `filters` can be.
        const responseSortOptions = ((payload || {}).result || {}).sort || [];
        if (Array.isArray(responseSortOptions) && responseSortOptions.length) {
          runtime.apiSortOptions = responseSortOptions;
        } else if (!Array.isArray(runtime.apiSortOptions)) {
          runtime.apiSortOptions = [];
        }

        runtime.pending = createFacetedPending(state);

        const applySearchState = function (nextState) {
          state.activeFilters = nextState.activeFilters.slice();
          state.sortBy = nextState.sortBy;
          state.sortDir = nextState.sortDir;
          state.page = nextState.page || 1;
          runtime.pending = createFacetedPending(state);
          updateSearchPageResults(container, config, query, state, runtime);
        };

        hideDesktopFilterToolbar(
          config,
          container,
          state,
          facetFilters,
          applySearchState,
        );
        renderMobileFilterBar(config, container, state, runtime, facetFilters);
        renderFiltersPanel(config, container, state, runtime, applySearchState);
        if (!products.length) {
          if (appendProducts) {
            if (paginationNode) {
              paginationNode.innerHTML = "";
            }
            return;
          }
          setQueryCount(config.noResultsMessage || "Showing 0 results");
          setSearchPageDocumentTitle(total);
          gridNode.innerHTML =
            '<p class="kartmax-search-page__empty">' +
            escapeHtml(config.noResultsMessage || "No matching products found.") +
            "</p>";
          if (paginationNode) {
            paginationNode.innerHTML = "";
          }
          if (loaderNode) {
            loaderNode.hidden = true;
          }
          revealKartmaxSearchPage();
          return;
        }

        setQueryCount(formatQueryResultCount(total));
        setSearchPageDocumentTitle(total);
        const existingCardCount = appendProducts
          ? gridNode.querySelectorAll(".kartmax-search-page__card").length
          : 0;
        const productCardsHtml = products
          .map(function (product, index) {
            return renderSearchProductCard(product, existingCardCount + index);
          })
          .join("");
        if (appendProducts) {
          gridNode.insertAdjacentHTML("beforeend", productCardsHtml);
        } else {
          gridNode.innerHTML = productCardsHtml;
        }
        // Bind event tracking before the cart handler (same order as the
        // collection page); tracking listens in the capture phase anyway.
        bindGridEventTracking(gridNode);
        bindProductCardActions(gridNode);
        const shownProducts = Math.min(
          total,
          gridNode.querySelectorAll(".kartmax-search-page__card").length,
        );
        renderSearchLoadMore(
          paginationNode,
          state,
          totalPages,
          shownProducts,
          total,
          function (nextPage) {
            state.page = nextPage;
            updateSearchPageResults(container, config, query, state, runtime, {
              appendProducts: true,
            });
          },
        );
        if (loaderNode) {
          loaderNode.hidden = true;
        }
        revealKartmaxSearchPage();
      })
      .catch(function () {
        if (requestId !== runtime.requestId) {
          return;
        }

        if (appendProducts) {
          setQueryCount("Could not load more results. Please try again.");
          const loadMoreButton = paginationNode && paginationNode.querySelector("[data-page]");
          if (loadMoreButton) {
            loadMoreButton.disabled = false;
            loadMoreButton.removeAttribute("aria-busy");
            loadMoreButton.textContent = "Load More";
          }
          return;
        }

        setQueryCount("Search temporarily unavailable.");
        gridNode.innerHTML =
          '<p class="kartmax-search-page__empty">KartmaX search is temporarily unavailable. Please try again.</p>';
        renderMobileFilterBar(config, container, state, runtime, []);
        if (paginationNode) {
          paginationNode.innerHTML = "";
        }
        if (loaderNode) {
          loaderNode.hidden = true;
        }
        revealKartmaxSearchPage();
      });
  }

  function productHref(product) {
    if (product.url) {
      try {
        const parsed = new URL(product.url, window.location.origin);
        if (parsed.origin === window.location.origin) {
          return parsed.pathname + parsed.search + parsed.hash;
        }
        return product.url;
      } catch (error) {
        return product.url;
      }
    }

    if (product.url_key) {
      return "/products/" + product.url_key;
    }

    const colorOption =
      Array.isArray(product.color_options) && product.color_options.length
        ? product.color_options[0]
        : null;
    if (colorOption && colorOption.url_key) {
      return "/products/" + colorOption.url_key;
    }

    const query = product.name || product.sku || "";
    return "/search?q=" + encodeURIComponent(query);
  }

  function parseMoneyValue(raw) {
    if (raw == null || raw === "") {
      return null;
    }
    if (typeof raw === "number") {
      return Number.isFinite(raw) ? raw : null;
    }
    if (Array.isArray(raw) && raw.length) {
      return parseMoneyValue(raw[0]);
    }
    if (typeof raw === "object") {
      return parseMoneyValue(
        raw.amount ?? raw.value ?? raw.price ?? raw.min ?? raw.selling_price,
      );
    }

    const cleaned = String(raw)
      .trim()
      .replace(/[^\d.,\-]/g, "")
      .replace(/,(?=\d{3}(?:\D|$))/g, "")
      .replace(",", ".");
    const value = Number(cleaned);
    return Number.isFinite(value) ? value : null;
  }

  function readProductNumber(product, keys) {
    if (!product || typeof product !== "object") {
      return null;
    }

    for (let index = 0; index < keys.length; index += 1) {
      const value = parseMoneyValue(product[keys[index]]);
      if (value != null && value > 0) {
        return value;
      }
    }

    return null;
  }

  function roundMoney(value) {
    return Math.round(Number(value) * 100) / 100;
  }

  // Shopify cents mixed with Kartmax AED major units (e.g. 6995 vs 49.95).
  function normalizePossiblyCents(value, peer) {
    if (!Number.isFinite(value) || value <= 0) {
      return value;
    }
    if (
      Number.isInteger(value) &&
      value >= 100 &&
      Number.isFinite(peer) &&
      peer > 0 &&
      value >= peer * 50
    ) {
      return roundMoney(value / 100);
    }
    return value;
  }

  function resolveProductImageUrl(product) {
    if (
      window.KartmaxProductLinks &&
      typeof window.KartmaxProductLinks.resolveProductImage === "function"
    ) {
      const linkedImage = window.KartmaxProductLinks.resolveProductImage(product);
      if (linkedImage) {
        return linkedImage;
      }
    }

    return typeof product.image === "string" ? product.image : "";
  }

  function resolveProductHandle(product) {
    if (
      window.KartmaxProductLinks &&
      typeof window.KartmaxProductLinks.resolveProductHandle === "function"
    ) {
      return window.KartmaxProductLinks.resolveProductHandle(product);
    }

    return typeof product.url_key === "string" ? product.url_key : "";
  }

  function readOfferBadge(product) {
  if (!product || typeof product !== "object") {
    return "";
  }

  /*
   * 1. PRIMARY:
   *    meta_offer_information.badge
   */
  let offerInfo = product.meta_offer_information;

  // Metafield may sometimes arrive as a JSON string.
  if (typeof offerInfo === "string") {
    try {
      offerInfo = JSON.parse(offerInfo);
    } catch (error) {
      offerInfo = null;
    }
  }

  if (
    offerInfo &&
    typeof offerInfo === "object" &&
    typeof offerInfo.badge === "string" &&
    offerInfo.badge.trim()
  ) {
    return offerInfo.badge.trim();
  }

  /*
   * 2. EXISTING PRODUCT BADGE
   */
  if (
    typeof product.badge === "string" &&
    product.badge.trim()
  ) {
    return product.badge.trim();
  }

  /*
   * 3. CALCULATE FROM PRICE + SELLING PRICE
   *
   * Example:
   * price = 120
   * selling_price = 57
   *
   * ((120 - 57) / 120) * 100 = 52.5
   * => 53% OFF
   */
  const price = readProductNumber(product, [
    "price",
    "price_min",
    "priceMin",
  ]);

  const sellingPrice = readProductNumber(product, [
    "selling_price",
    "sellingPrice",
    "special_price",
    "specialPrice",
    "discounted_price",
    "discountedPrice",
  ]);

  if (
    Number.isFinite(price) &&
    Number.isFinite(sellingPrice) &&
    price > 0 &&
    sellingPrice > 0 &&
    price > sellingPrice
  ) {
    const discountPercentage = Math.round(
      ((price - sellingPrice) / price) * 100
    );

    if (discountPercentage > 0) {
      return discountPercentage + "% OFF";
    }
  }

  /*
   * 4. FALLBACK TO EXISTING DISCOUNT FIELDS
   */
  const existingDiscount =
    product.discount ??
    product.percentage ??
    product.discount_percentage ??
    product.discountPercentage;

  if (
    existingDiscount !== null &&
    existingDiscount !== undefined &&
    existingDiscount !== ""
  ) {
    const discountValue = parseFloat(
      String(existingDiscount).replace("%", "").trim()
    );

    if (Number.isFinite(discountValue) && discountValue > 0) {
      return Math.round(discountValue) + "% OFF";
    }
  }

  /*
   * 5. discount_filter fallback
   */
  if (
    typeof product.discount_filter === "string" &&
    product.discount_filter.trim()
  ) {
    const match = product.discount_filter.match(/(\d+(?:\.\d+)?)\s*%?/);

    if (match) {
      return Math.round(Number(match[1])) + "% OFF";
    }
  }

  return "";
}
  // Real prices only; RSP from `price` when `selling_price` exists (same as collection PLP).
  function resolveProductPricing(product) {
    const dedicatedSalePrice = readProductNumber(product, [
      "selling_price",
      "sellingPrice",
      "special_price",
      "specialPrice",
      "discounted_price",
      "discountedPrice",
    ]);
    const fallbackPrice = readProductNumber(product, [
      "price",
      "price_min",
      "priceMin",
    ]);
    let salePrice = dedicatedSalePrice || fallbackPrice;

    const rspKeys = [
      "rsp",
      "rrp",
      "msrp",
      "compare_at_price",
      "compareAtPrice",
      "price_max",
      "highPrice",
      "regular_price",
      "regularPrice",
      "original_price",
      "originalPrice",
    ];
    // Kartmax: `price` is list/RSP when a dedicated selling/special price exists.
    if (dedicatedSalePrice) {
      rspKeys.push("price");
    }

    let rsp = readProductNumber(product, rspKeys);
    salePrice = normalizePossiblyCents(salePrice, rsp);
    rsp = normalizePossiblyCents(rsp, salePrice);

    if (!rsp || !salePrice || rsp <= salePrice) {
      rsp = null;
    }

    const savings =
      rsp && salePrice && rsp > salePrice ? roundMoney(rsp - salePrice) : null;

    return {
      salePrice: Number.isFinite(salePrice) ? roundMoney(salePrice) : null,
      rsp: Number.isFinite(rsp) ? roundMoney(rsp) : null,
      savings: savings,
      badge: readOfferBadge(product),
    };
  }

  function formatPriceNumber(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) {
      return "";
    }
    return (Math.round(amount * 100) / 100).toFixed(2);
  }

  function renderMoneyWithDirham(value) {
    const amountText = formatPriceNumber(value);
    if (!amountText) {
      return "";
    }
    return DIRHAM_ICON_SVG + " " + amountText;
  }

  function renderProductPriceHtml(pricing) {
    if (!pricing || !pricing.salePrice) {
      return "";
    }

    let html =
      '<div class="product-price flex flex-column" itemprop="offers" itemscope itemtype="http://schema.org/AggregateOffer">' +
      '<meta itemprop="priceCurrency" content="AED">' +
      '<meta itemprop="lowPrice" content="' +
      escapeAttribute(formatPriceNumber(pricing.salePrice)) +
      '">';

    if (pricing.rsp) {
      html +=
        '<meta itemprop="highPrice" content="' +
        escapeAttribute(formatPriceNumber(pricing.rsp)) +
        '">';
    }

    html +=
      '<span class="product-price__price flex align-items-end color-text-primary h2 weight-bold" data-ref="productPrice">' +
      renderMoneyWithDirham(pricing.salePrice) +
      "</span>";

    if (pricing.savings && pricing.savings > 0) {
      html +=
        '<span class="product-price__saving color-error weight-bold">' +
        '<span data-ref="productSaving" class="flex align-items-center">' +
        renderMoneyWithDirham(pricing.savings) +
        " Off RSP</span></span>";
    }

    html += "</div>";
    return html;
  }

  // offer badge image indexed by KartmaX in
  // `meta_product_badges` (e.g. half-price-rrp.png). Accepts a single URL,
  // an array of URLs, or a JSON-encoded array. Returns "" when no valid URL.
  function renderProductBadgeImageHtml(product) {
    let raw = product && product.meta_product_badges;

    if (typeof raw === "string" && raw.trim().charAt(0) === "[") {
      try {
        raw = JSON.parse(raw);
      } catch (error) {
        // Not JSON — treat as a plain URL string.
      }
    }

    const urls = (Array.isArray(raw) ? raw : [raw])
      .map(function (value) {
        return typeof value === "string" ? value.trim() : "";
      })
      .filter(function (value) {
        return /^https?:\/\//i.test(value) || value.indexOf("//") === 0;
      });

    if (!urls.length) {
      return "";
    }

    return (
      '<div class="kartmax-product-badge-image">' +
      urls
        .map(function (url) {
          return (
            '<img class="kartmax-product-badge-image__img" src="' +
            escapeAttribute(url) +
            '" alt="" loading="lazy" decoding="async">'
          );
        })
        .join("") +
      "</div>"
    );
  }

  function buildProductPageUrl(product) {
    if (
      window.KartmaxProductLinks &&
      typeof window.KartmaxProductLinks.buildProductPageUrl === "function"
    ) {
      const linkedUrl = window.KartmaxProductLinks.buildProductPageUrl(product);
      if (linkedUrl) {
        return linkedUrl;
      }
    }

    return productHref(product);
  }

  function renderSearchProductCard(product, cardIndex) {
    if (!product || typeof product !== "object") {
      return "";
    }

    const productPageUrl = buildProductPageUrl(product) || "#";
    const imageUrl = resolveProductImageUrl(product);
    const handle = resolveProductHandle(product);
    const pricing = resolveProductPricing(product);
    const position = Number(cardIndex);
    const cardPosition =
      Number.isFinite(position) && position >= 0 ? String(position + 1) : "";
    // badge image (meta_product_badges) takes priority
    // over the text badge; if an image exists, only the image is shown.
    const badgeImageHtml = renderProductBadgeImageHtml(product);
    const badgeHtml = badgeImageHtml
      ? '<div class="product-card-badges product-card-badges--image">' +
        badgeImageHtml +
        "</div>"
      : pricing.badge
        ? '<div class="product-card-badges">' +
          '<span class="product-card-badges__badge product-card-badges__badge--sale">' +
          escapeHtml(pricing.badge) +
          "</span></div>"
        : "";
    const image = imageUrl
      ? '<img class="product-card__image" src="' +
        escapeAttribute(imageUrl) +
        '" alt="' +
        escapeAttribute(product.name || "Product image") +
        '" loading="lazy">'
      : '<div class="product-card__image product-card__image--placeholder">No image</div>';
    const priceHtml = renderProductPriceHtml(pricing);
    // Variant/group id, price and sku for product_click / add_to_cart tracking.
    const clickIds = getProductTrackingIds(product);
    const skuValue = product.sku || product.variant_sku || "";
    const quickAddHtml = handle
      ? '<div class="product-card-quick-add-trigger">' +
        '<button type="button" class="product-card-quick-add-trigger__button" data-kartmax-add-to-cart data-product-handle="' +
        escapeAttribute(handle) +
        '" data-product-url="' +
        escapeAttribute(productPageUrl) +
        '" data-kartmax-variant-id="' +
        escapeAttribute(String(clickIds.variantId ?? "")) +
        '" data-kartmax-group-id="' +
        escapeAttribute(String(clickIds.groupId ?? "")) +
        '" data-kartmax-price="' +
        escapeAttribute(pricing.salePrice != null ? String(pricing.salePrice) : "") +
        '" data-kartmax-sku="' +
        escapeAttribute(String(skuValue)) +
        '">' +
        TROLLEY_ICON_SVG +
        '<span class="visually-hidden">Add to cart</span>' +
        "</button></div>"
      : "";
    // URL + name help recover Shopify handle when Kartmax url_key 404s
    const wishlistHtml = handle
      ? '<div class="wishlist-hero-custom-button wishlisthero-floating" data-kartmax-wishlist data-product-handle="' +
        escapeAttribute(handle) +
        '" data-product-url="' +
        escapeAttribute(productPageUrl) +
        '" data-product-name="' +
        escapeAttribute(product.name || "") +
        '" data-wlh-mode="icon_only" data-wlh-view="Collection" style="left: auto;"></div>'
      : "";

    return (
      '<article class="product-card kartmax-search-page__card" role="listitem"' +
      (cardPosition
        ? ' data-kartmax-position="' + escapeAttribute(cardPosition) + '"'
        : "") +
      ' data-kartmax-product-id="' +
      escapeAttribute(String(clickIds.variantId ?? "")) +
      '" data-kartmax-group-id="' +
      escapeAttribute(String(clickIds.groupId ?? "")) +
      '">' +
      wishlistHtml +
      '<div class="product-card__image-container">' +
      '<a class="product-card__image-link" href="' +
      escapeAttribute(productPageUrl) +
      '" aria-label="' +
      escapeAttribute(product.name || "Product") +
      '">' +
      image +
      "</a>" +
      badgeHtml +
      quickAddHtml +
      "</div>" +
      '<div class="product-card__information">' +
      '<a class="product-card__title color-text-primary" href="' +
      escapeAttribute(productPageUrl) +
      '">' +
      escapeHtml(product.name || "Untitled product") +
      "</a>" +
      '<div class="product-card__bottom-container">' +
      '<div class="product-card__price-container">' +
      priceHtml +
      "</div>" +
      '<a class="product-card__cta button button--secondary button--small" href="' +
      escapeAttribute(productPageUrl) +
      '">' +
      '<span class="hidden-below-tablet">View product</span>' +
      '<span class="hidden-above-tablet">View</span>' +
      "</a></div></div></article>"
    );
  }

  // Legacy names still set by the theme cart script. Read only as a fallback,
  // so quick add keeps working until that script uses the functional names
  // (window.KartmaxProductCardActions, KartmaxCart.__isThemeCart). Remove once
  // it has been renamed.
  var LEGACY_CARD_ACTIONS_GLOBAL = "__KartmaxSantosh";
  var LEGACY_THEME_CART_FLAG = "__santoshThemeCart";
  var LEGACY_QUICK_ADD_BOUND_KEY = "santoshAtcBound";

  // Product-card actions API (quick add + wishlist).
  function getProductCardActionsApi() {
    return window.KartmaxProductCardActions || window[LEGACY_CARD_ACTIONS_GLOBAL] || null;
  }

  // True when KartmaxCart is the theme's own cart API.
  function isThemeCartApi(cart) {
    return Boolean(cart && (cart.__isThemeCart === true || cart[LEGACY_THEME_CART_FLAG] === true));
  }

  // Prefer the product-card actions API (CDN-safe); never use the CDN binder.
  function bindProductCardActions(gridNode) {
    const cardActions = getProductCardActionsApi();
    if (
      cardActions &&
      typeof cardActions.bindProductCardActions === "function"
    ) {
      cardActions.bindProductCardActions(gridNode);
      return;
    }

    if (
      window.KartmaxCart &&
      isThemeCartApi(window.KartmaxCart) &&
      typeof window.KartmaxCart.bindProductCardActions === "function"
    ) {
      window.KartmaxCart.bindProductCardActions(gridNode);
      return;
    }

    // Last resort: call addProductByHandle with icon-restore proxy (CDN uses textContent).
    // Bound flag (legacy key still honoured, see LEGACY_QUICK_ADD_BOUND_KEY).
    if (
      !gridNode ||
      gridNode.dataset.kartmaxQuickAddBound === "true" ||
      gridNode.dataset[LEGACY_QUICK_ADD_BOUND_KEY] === "true"
    ) {
      return;
    }
    gridNode.dataset.kartmaxQuickAddBound = "true";
    gridNode.dataset.kartmaxCartBound = "true";
    gridNode.addEventListener("click", function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }
      const button = event.target.closest("[data-kartmax-add-to-cart]");
      if (!button) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      const handle = button.getAttribute("data-product-handle") || "";
      const fallbackUrl = button.getAttribute("data-product-url") || "";
      const originalHtml = button.innerHTML;
      const addFn =
        (cardActions && cardActions.addProductByHandle) ||
        (window.KartmaxCart && window.KartmaxCart.addProductByHandle);
      if (typeof addFn !== "function") {
        if (fallbackUrl && fallbackUrl !== "#") {
          window.location.href = fallbackUrl;
        }
        return;
      }
      const proxy = {
        get disabled() {
          return button.disabled;
        },
        set disabled(value) {
          button.disabled = Boolean(value);
        },
        setAttribute: function (name, value) {
          button.setAttribute(name, value);
        },
        removeAttribute: function (name) {
          button.removeAttribute(name);
        },
        get textContent() {
          return button.textContent;
        },
        set textContent(value) {
          const text = String(value || "").trim();
          // loader instead of Adding/Added text.
          if (/^adding/i.test(text) || /^added$/i.test(text)) {
            button.disabled = true;
            button.setAttribute("aria-busy", "true");
            button.innerHTML =
              '<span class="kartmax-atc-loader" aria-live="polite" aria-label="Adding to cart">' +
              '<span class="kartmax-atc-spinner" aria-hidden="true"></span></span>';
            return;
          }
          button.disabled = false;
          button.removeAttribute("aria-busy");
          button.innerHTML = originalHtml;
        },
        get innerHTML() {
          return button.innerHTML;
        },
        set innerHTML(value) {
          if (value === originalHtml) {
            button.disabled = false;
            button.innerHTML = originalHtml;
            return;
          }
          button.innerHTML = value;
        },
      };
      addFn(handle, { button: proxy, fallbackUrl: fallbackUrl });
    });
  }

  // product_click + add_to_cart tracking for the results grid (shared
  // KartmaxSearchAttribution module; only active when the URL has ?q=).
  function bindGridEventTracking(root) {
    const attribution = window.KartmaxSearchAttribution;
    const bindGrid =
      attribution &&
      (attribution.bindProductGridTracking || attribution.bindSearchGridTracking);
    if (typeof bindGrid === "function") {
      bindGrid(root, {
        cardSelector: ".product-card.kartmax-search-page__card",
      });
    }
  }

  // Product ids for the card tracking attributes. Adjust the field names if
  // the KartmaX product payload differs.
  function getProductTrackingIds(product) {
    if (!product || typeof product !== "object") {
      return { variantId: null, groupId: null };
    }
    const variantId =
      product.variant_id ??
      product.variantId ??
      product.id ??
      product.product_id ??
      null;
    const groupId =
      product.group_id ??
      product.groupId ??
      product.product_group_id ??
      product.id ??
      null;
    return { variantId: variantId, groupId: groupId };
  }

  function applyFacetedUiTheme(container, ui) {
    container.style.setProperty("--kmx-plp-accent", ui.accentColor || "#0053a3");
    container.style.setProperty("--kmx-plp-accent-border", ui.accentColor || "#0053a3");
    container.style.setProperty("--kmx-plp-button-text", ui.accentColor || "#0053a3");
    container.style.setProperty("--kmx-plp-drawer-width", ui.drawerWidth || "40rem");
    container.style.setProperty("--kmx-borders-red", "#e30613");
    container.style.setProperty("--kmx-sidebar-width", "20rem");
    container.style.setProperty("--kmx-sort-bg", "#f2f2f2");
    container.style.setProperty("--kmx-facet-border", "#e5e5e5");
  }

  function createFacetedPending(state) {
    return {
      activeFilters: state.activeFilters.slice(),
      sortBy: state.sortBy || "",
      sortDir: state.sortDir || "desc",
    };
  }

  function combineFiltersForApi(filters) {
    return (filters || []).filter(Boolean).join("|");
  }

  // sticky sidebar top = live header bottom (search)
  function syncStickySidebarOffset(container) {
    function measureHeaderBottom() {
      let bottom = 0;
      const nodes = document.querySelectorAll(
        "site-header-wrapper, .site-header-wrapper, #shopify-section-header, .announcement-bar, .top-bar, .usp-bar, [id*='announcement']"
      );
      nodes.forEach(function (node) {
        const rect = node.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) {
          return;
        }
        const style = window.getComputedStyle(node);
        const isPinned = style.position === "fixed" || style.position === "sticky";
        if ((rect.top <= 1 || (isPinned && rect.top < 100)) && rect.bottom > bottom) {
          bottom = rect.bottom;
        }
      });
      const wrap = document.querySelector("site-header-wrapper, .site-header-wrapper");
      if (wrap) {
        const rect = wrap.getBoundingClientRect();
        if (rect.bottom > bottom) {
          bottom = rect.bottom;
        }
      }
      return Math.max(Math.ceil(bottom + 12), 96);
    }

    function update() {
      const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
      if (!sidebar) {
        return;
      }
      if (!window.matchMedia("(min-width: 990px)").matches) {
        sidebar.style.removeProperty("top");
        sidebar.style.removeProperty("max-height");
        container.style.removeProperty("--kmx-sticky-offset");
        return;
      }
      const offsetPx = measureHeaderBottom();
      const offset = offsetPx + "px";
      container.style.setProperty("--kmx-sticky-offset", offset);
      sidebar.style.position = "sticky";
      sidebar.style.alignSelf = "start";
      sidebar.style.top = offset;
      sidebar.style.maxHeight = "calc(100vh - " + offset + " - 0.75rem)";
      sidebar.style.overflowX = "hidden";
      sidebar.style.overflowY = "auto";
    }

    if (container.dataset.kmxStickyBound === "true") {
      update();
      return;
    }
    container.dataset.kmxStickyBound = "true";
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    if (typeof ResizeObserver !== "undefined") {
      const wrap = document.querySelector("site-header-wrapper, .site-header-wrapper");
      if (wrap) {
        new ResizeObserver(update).observe(wrap);
      }
    }
  }

  function bindFiltersChrome(config, container) {
    const titleNode = container.querySelector("[data-kartmax-drawer-title]");
    const applyButton = container.querySelector("[data-kartmax-filter-apply]");
    const clearButton = container.querySelector("[data-kartmax-filter-clear]");

    if (titleNode) {
      titleNode.textContent = config.ui.drawerTitle || "Sort & Filter";
    }
    const mobileTitle = container.querySelector(".kartmax-search-page__sidebar-mobile-title");
    if (mobileTitle) {
      mobileTitle.textContent = config.ui.drawerTitle || "Sort & Filter";
    }

    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    if (sidebar && window.matchMedia("(min-width: 990px)").matches) {
      sidebar.setAttribute("aria-hidden", "false");
    }

    if (applyButton) {
      applyButton.textContent = config.ui.applyFiltersLabel;
    }

    if (clearButton) {
      clearButton.textContent = config.ui.clearFiltersLabel;
    }

    // Apply button mobile-only (search)
    function syncApplyFilterVisibility() {
      const btn = container.querySelector("[data-kartmax-filter-apply]");
      if (!btn) {
        return;
      }
      const isMobile = window.matchMedia("(max-width: 989px)").matches;
      btn.hidden = !isMobile;
      btn.style.setProperty("display", isMobile ? "block" : "none", "important");
    }
    syncApplyFilterVisibility();
    if (!container.dataset.kmxApplyVisibilityBound) {
      container.dataset.kmxApplyVisibilityBound = "true";
      window.addEventListener("resize", syncApplyFilterVisibility);
    }

    syncStickySidebarOffset(container);

    container.querySelectorAll("[data-kartmax-filters-close], [data-kartmax-filters-backdrop]").forEach(function (node) {
      node.addEventListener("click", function () {
        closeMobileFilters(container);
      });
    });

    document.addEventListener("keydown", function (event) {
      const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
      if (event.key === "Escape" && sidebar && sidebar.classList.contains("is-mobile-open")) {
        closeMobileFilters(container);
      }
    });
  }

  function openMobileFilters(container, facetKey) {
    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    const backdrop = container.querySelector("[data-kartmax-filters-backdrop]");
    if (!sidebar) {
      return;
    }

    sidebar.classList.add("is-mobile-open");
    sidebar.setAttribute("aria-hidden", "false");
    if (backdrop) {
      backdrop.hidden = false;
    }
    document.body.classList.add("kartmax-search-page-drawer-open");

    if (facetKey) {
      expandFacet(container, facetKey);
      const toggle = sidebar.querySelector(
        '[data-kartmax-facet-toggle][data-facet-key="' + facetKey + '"]',
      );
      if (toggle) {
        window.requestAnimationFrame(function () {
          toggle.scrollIntoView({ block: "nearest" });
        });
      }
    }
  }

  function closeMobileFilters(container) {
    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    const backdrop = container.querySelector("[data-kartmax-filters-backdrop]");
    if (!sidebar) {
      return;
    }

    sidebar.classList.remove("is-mobile-open");
    if (window.matchMedia("(max-width: 989px)").matches) {
      sidebar.setAttribute("aria-hidden", "true");
    } else {
      sidebar.setAttribute("aria-hidden", "false");
    }
    if (backdrop) {
      backdrop.hidden = true;
    }
    document.body.classList.remove("kartmax-search-page-drawer-open");
  }

  // allow empty key to collapse all facets.
  function expandFacet(container, facetKey) {
    const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
    if (!sidebar) {
      return;
    }

    sidebar.querySelectorAll("[data-kartmax-facet]").forEach(function (facetNode) {
      const isTarget =
        !!facetKey && facetNode.getAttribute("data-facet-key") === facetKey;
      facetNode.classList.toggle("is-expanded", isTarget);
      const body = facetNode.querySelector("[data-kartmax-facet-body]");
      const toggle = facetNode.querySelector("[data-kartmax-facet-toggle]");
      if (body) {
        body.hidden = !isTarget;
      }
      if (toggle) {
        toggle.setAttribute("aria-expanded", isTarget ? "true" : "false");
      }
    });
  }

  function getFacetLabelKey(filter) {
    return (filter.code || filter.filter_lable || "filter").toLowerCase();
  }

  function isSaleFacet(filter) {
    return /sale/i.test(filter.filter_lable || filter.code || "");
  }

  function isSortOnlyFilter(filter) {
    const code = (filter.code || "").toLowerCase();
    const label = (filter.filter_lable || "").toLowerCase();
    return code === "sort" || code === "sort_by" || code === "_sort" || /^sort\b/.test(label);
  }

  function getFacetFilters(filters) {
    return (filters || []).filter(function (filter) {
      return (
        !isSortOnlyFilter(filter) &&
        Array.isArray(filter.options) &&
        filter.options.length
      );
    }).map(function (filter) {
      return normalizeFacetOptions(filter);
    });
  }

  function isPriceFacet(filter) {
    return /price/i.test(
      String((filter && filter.code) || "") +
      " " +
      String((filter && filter.filter_lable) || ""),
    );
  }

  function getPriceOptionSortValue(option) {
    const text = String((option && (option.value || option.value_key)) || "")
      .replace(/,/g, "");
    const match = text.match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : Number.POSITIVE_INFINITY;
  }

  function normalizeFacetOptions(filter, options) {
    const normalizedOptions = (options || filter.options || []).slice();
    if (isPriceFacet(filter)) {
      normalizedOptions.sort(function (left, right) {
        return getPriceOptionSortValue(left) - getPriceOptionSortValue(right);
      });
    }
    return {
      ...filter,
      options: normalizedOptions,
    };
  }

  function refreshPreservedOptionCount(filter, option, activeFilters, resultTotal) {
    const preservedOption = { ...option };
    if (!isPriceFacet(filter)) {
      return preservedOption;
    }

    // KartmaX can omit counts after filters are applied; avoid stale price counts.
    delete preservedOption.count;
    delete preservedOption.doc_count;
    delete preservedOption.product_count;

    return preservedOption;
  }

  // KartmaX often omits facet options after a filter is applied. Keep the full
  // option list from the prior render so users can multi-select within a facet.
  function mergeFacetFilters(previousFilters, responseFilters, activeFilters, resultTotal) {
    const previous = Array.isArray(previousFilters) ? previousFilters : [];
    const response = Array.isArray(responseFilters) ? responseFilters : [];
    const active = new Set(Array.isArray(activeFilters) ? activeFilters : []);
    const responseByKey = new Map();

    response.forEach(function (filter) {
      responseByKey.set(getFacetLabelKey(filter), filter);
    });

    const merged = [];

    previous.forEach(function (previousFilter) {
      const key = getFacetLabelKey(previousFilter);
      const responseFilter = responseByKey.get(key);

      if (!responseFilter) {
        const selectedOptions = (previousFilter.options || []).filter(function (option) {
          return active.has(buildFilterValue(option));
        });
        if (selectedOptions.length) {
          merged.push(normalizeFacetOptions({
            ...previousFilter,
            options: selectedOptions.map(function (option) {
              return refreshPreservedOptionCount(
                previousFilter,
                option,
                activeFilters,
                resultTotal,
              );
            }),
          }));
        }
        return;
      }

      const options = (responseFilter.options || []).slice();
      const responseValues = new Set(options.map(buildFilterValue));
      (previousFilter.options || []).forEach(function (option) {
        const value = buildFilterValue(option);
        if (!value || responseValues.has(value)) {
          return;
        }
        options.push(refreshPreservedOptionCount(
          responseFilter,
          option,
          activeFilters,
          resultTotal,
        ));
        responseValues.add(value);
      });

      merged.push(normalizeFacetOptions({
        ...responseFilter,
        options: options,
      }));
      responseByKey.delete(key);
    });

    response.forEach(function (filter) {
      if (responseByKey.has(getFacetLabelKey(filter))) {
        merged.push(normalizeFacetOptions(filter));
      }
    });

    return merged;
  }

  // dynamic sort options now come from the API's
  // top-level `result.sort` array: [{ code, label, dir }, ...]. Each entry is
  // turned into a "code:dir" value so it flows straight through
  // parseSortValue()/getSortValue()/buildSearchUrl() unchanged.
  //
  // `filters` is kept only as a fallback for older/alternate responses that
  // still embed a sort-like entry inside `result.filters`.
  function getSortOptions(sortDefs, filters) {
    const list = Array.isArray(sortDefs) ? sortDefs : [];

    if (list.length) {
      return [
        { value: "", label: "Featured" },
      ].concat(
        list.map(function (item) {
          const code = item.code || item.value_key || "";
          const dir =
            String(item.dir || item.direction || "desc").toLowerCase() === "asc"
              ? "asc"
              : "desc";
          return {
            value: code ? code + ":" + dir : "",
            label: item.label || item.filter_lable || item.value || code || "Sort option",
          };
        }),
      );
    }

    // Fallback: sort embedded inside `filters` (legacy/alternate shape).
    const sortFilter = (filters || []).find(function (filter) {
      return isSortOnlyFilter(filter);
    });

    if (sortFilter && Array.isArray(sortFilter.options) && sortFilter.options.length) {
      return [{ value: "", label: "Featured" }].concat(
        sortFilter.options.map(function (option) {
          return {
            value: option.value_key || "",
            label: option.value || option.value_key || "Sort option",
          };
        }),
      );
    }

    return DEFAULT_SORT_OPTIONS.slice();
  }

  function getSortValue(state) {
    if (!state.sortBy) {
      return "";
    }

    return state.sortBy + ":" + (state.sortDir === "asc" ? "asc" : "desc");
  }

  function parseSortValue(value) {
    if (!value) {
      return { sortBy: "", sortDir: "desc" };
    }

    const parts = value.split(":");
    return {
      sortBy: parts[0] || "",
      sortDir: parts[1] === "asc" ? "asc" : "desc",
    };
  }

  function getSortLabel(sortOptions, state) {
    const currentValue = getSortValue(state);
    const match = sortOptions.find(function (option) {
      return option.value === currentValue;
    });

    return match ? match.label : "Featured";
  }

  function renderSidebarSort(config, container, state, runtime, onChange) {
    const node = container.querySelector("[data-kartmax-sidebar-sort]");
    if (!node) {
      return;
    }

    const sortOptions = getSortOptions(runtime.apiSortOptions, runtime.apiFilters || []);
    const currentLabel = getSortLabel(sortOptions, state);
    const listId = "kartmax-sidebar-sort-list-search-page";

    node.innerHTML =
      '<div class="kartmax-search-page__sidebar-sort-box">' +
        '<span class="kartmax-search-page__sidebar-sort-prefix">Sort by :</span>' +
      '<button type="button" class="kartmax-search-page__sidebar-sort-trigger" data-kartmax-sort-trigger aria-haspopup="listbox" aria-expanded="false" aria-controls="' +
      listId +
      '">' +

      '<span class="kartmax-search-page__sidebar-sort-value">' +
      escapeHtml(currentLabel) +
      "</span>" +
      '<span class="kartmax-search-page__sidebar-sort-chevron" aria-hidden="true"></span>' +
      "</button>" +
      '<ul class="kartmax-search-page__sidebar-sort-list" id="' +
      listId +
      '" role="listbox" hidden data-kartmax-sort-list>' +
      sortOptions
        .map(function (option) {
          const selected = option.value === getSortValue(state) ? " is-selected" : "";
          return (
            '<li role="option" aria-selected="' +
            (selected ? "true" : "false") +
            '">' +
            '<button type="button" class="kartmax-search-page__sidebar-sort-option' +
            selected +
            '" data-sort-value="' +
            escapeAttribute(option.value) +
            '">' +
            escapeHtml(option.label) +
            "</button>" +
            "</li>"
          );
        })
        .join("") +
      "</ul>" +
      "</div>";

    const trigger = node.querySelector("[data-kartmax-sort-trigger]");
    const list = node.querySelector("[data-kartmax-sort-list]");

    if (!trigger || !list) {
      return;
    }

    function closeList() {
      list.hidden = true;
      trigger.setAttribute("aria-expanded", "false");
      node.classList.remove("is-open");
    }

    trigger.addEventListener("click", function (event) {
      event.stopPropagation();
      const willOpen = list.hidden;
      closeList();
      if (willOpen) {
        list.hidden = false;
        trigger.setAttribute("aria-expanded", "true");
        node.classList.add("is-open");
      }
    });

    list.querySelectorAll("[data-sort-value]").forEach(function (button) {
      button.addEventListener("click", function () {
        closeList();
        onChange(parseSortValue(button.getAttribute("data-sort-value") || ""));
      });
    });

    if (!node.dataset.sortBound) {
      node.dataset.sortBound = "true";
      document.addEventListener("click", function (event) {
        if (!node.contains(event.target)) {
          closeList();
        }
      });
    }
  }

  // keep left sidebar; hide desktop chip toolbar.
  function hideDesktopFilterToolbar(config, container) {
    const toolbar = container.querySelector("[data-kartmax-desktop-toolbar]");
    if (toolbar) {
      toolbar.hidden = true;
      toolbar.innerHTML = "";
    }
  }

  // mobile dock; tick on Filter when filters applied
  function renderMobileFilterBar(config, container, state, runtime, facetFilters) {
    const bar = container.querySelector("[data-kartmax-mobile-bar]");
    if (!bar) {
      return;
    }

    if (!config.ui.showFilterButton) {
      bar.hidden = true;
      bar.innerHTML = "";
      document.body.classList.remove("kartmax-mobile-dock-active");
      return;
    }

    const hasAppliedFilters =
      Array.isArray(state.activeFilters) && state.activeFilters.length > 0;
    const filterTickHtml = hasAppliedFilters
      ? '<span class="kartmax-search-page__mobile-dock-tick" aria-hidden="true">✓</span>'
      : "";

    bar.hidden = false;
    bar.classList.add("kartmax-search-page__mobile-bar--dock");
    document.body.classList.add("kartmax-mobile-dock-active");
    bar.innerHTML =
      '<button type="button" class="kartmax-search-page__mobile-dock-btn kartmax-search-page__mobile-dock-btn--filters' +
      (hasAppliedFilters ? " is-filtered" : "") +
      '" data-kartmax-mobile-open-filters>' +
      '<svg class="kartmax-search-page__mobile-dock-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path stroke="currentColor" stroke-width="1.7" stroke-linecap="round" d="M4 7h16M4 12h16M4 17h16"/>' +
      '<circle cx="9" cy="7" r="1.7" fill="currentColor"/>' +
      '<circle cx="15" cy="12" r="1.7" fill="currentColor"/>' +
      '<circle cx="11" cy="17" r="1.7" fill="currentColor"/>' +
      "</svg>" +
      "<span>Filter</span>" +
      filterTickHtml +
      "</button>" +
      '<button type="button" class="kartmax-search-page__mobile-dock-btn kartmax-search-page__mobile-dock-btn--sort" data-kartmax-mobile-sort>' +
      "<span>Sort</span>" +
      '<span class="kartmax-search-page__mobile-dock-chevron" aria-hidden="true"></span>' +
      "</button>";

    const openFiltersButton = bar.querySelector("[data-kartmax-mobile-open-filters]");
    if (openFiltersButton) {
      openFiltersButton.addEventListener("click", function () {
        const sidebar = container.querySelector("[data-kartmax-filters-sidebar]");
        if (sidebar && sidebar.classList.contains("is-mobile-open")) {
          closeMobileFilters(container);
          return;
        }
        openMobileFilters(container, "");
      });
    }

    const sortButton = bar.querySelector("[data-kartmax-mobile-sort]");
    if (sortButton) {
      sortButton.addEventListener("click", function () {
        openMobileFilters(container, "");
        const sortTrigger = container.querySelector("[data-kartmax-sort-trigger]");
        if (sortTrigger) {
          sortTrigger.click();
        }
      });
    }
  }

  // desktop auto-apply; mobile Apply; Clear only when filters on
  function isMobileFilterViewport() {
    return window.matchMedia("(max-width: 989px)").matches;
  }

  function syncClearFilterButton(container, pending) {
    const clearButton = container.querySelector("[data-kartmax-filter-clear]");
    if (!clearButton) {
      return;
    }
    const hasFilters =
      Array.isArray(pending && pending.activeFilters) &&
      pending.activeFilters.length > 0;
    clearButton.hidden = !hasFilters;
  }

  function renderFiltersPanel(config, container, state, runtime, onApply) {
    const filtersNode = container.querySelector("[data-kartmax-sidebar-filters]");
    const clearButton = container.querySelector("[data-kartmax-filter-clear]");
    const applyButton = container.querySelector("[data-kartmax-filter-apply]");
    if (!filtersNode || !clearButton) {
      return;
    }

    const pending = runtime.pending;
    const facetFilters = runtime.facetFilters || [];

    function commitFilters() {
      if (isMobileFilterViewport()) {
        closeMobileFilters(container);
      }
      onApply({
        activeFilters: pending.activeFilters.slice(),
        sortBy: pending.sortBy,
        sortDir: pending.sortDir,
        page: 1,
      });
      window.requestAnimationFrame(function () {
        scrollToSearchResults(container);
      });
    }

    renderSidebarSort(config, container, state, runtime, function (nextSort) {
      pending.sortBy = nextSort.sortBy;
      pending.sortDir = nextSort.sortDir;
      commitFilters();
    });

    syncClearFilterButton(container, pending);

    if (!facetFilters.length) {
      filtersNode.innerHTML =
        '<p class="kartmax-search-page__sidebar-empty">No filters available for this search.</p>';
      clearButton.onclick = function () {
        pending.activeFilters = [];
        syncClearFilterButton(container, pending);
        commitFilters();
      };
      if (applyButton) {
        applyButton.onclick = function () {
          commitFilters();
        };
      }
      return;
    }

    filtersNode.innerHTML = facetFilters
      .map(function (filter) {
        const label = filter.filter_lable || filter.code || "Filter";
        const facetKey = getFacetLabelKey(filter);
        const isExpanded = runtime.expandedFacetKey === facetKey;
        const saleClass = isSaleFacet(filter) ? " kartmax-search-page__facet--sale" : "";
        const options = (filter.options || [])
          .map(function (option) {
            const value = buildFilterValue(option);
            const checked = pending.activeFilters.indexOf(value) !== -1 ? " checked" : "";
            const count = option.count ?? option.doc_count ?? option.product_count;
            const countHtml = Number.isFinite(Number(count))
              ? '<span class="kartmax-search-page__facet-option-count">(' +
                escapeHtml(String(count)) +
                ")</span>"
              : "";
            return (
              '<label class="kartmax-search-page__facet-option">' +
              '<input type="checkbox" value="' +
              escapeAttribute(value) +
              '" data-kartmax-facet-input' +
              checked +
              ">" +
              '<span class="kartmax-search-page__facet-option-label">' +
              escapeHtml(option.value || option.value_key || value) +
              "</span>" +
              countHtml +
              "</label>"
            );
          })
          .join("");

        return (
          '<div class="kartmax-search-page__facet' +
          saleClass +
          (isExpanded ? " is-expanded" : "") +
          '" data-kartmax-facet data-facet-key="' +
          escapeAttribute(facetKey) +
          '">' +
          '<button type="button" class="kartmax-search-page__facet-toggle" data-kartmax-facet-toggle data-facet-key="' +
          escapeAttribute(facetKey) +
          '" aria-expanded="' +
          (isExpanded ? "true" : "false") +
          '">' +
          '<span class="kartmax-search-page__facet-label">' +
          escapeHtml(label) +
          "</span>" +
          '<span class="kartmax-search-page__facet-chevron" aria-hidden="true"></span>' +
          "</button>" +
          '<div class="kartmax-search-page__facet-body" data-kartmax-facet-body' +
          (isExpanded ? "" : " hidden") +
          ">" +
          options +
          "</div>" +
          "</div>"
        );
      })
      .join("");

    filtersNode.querySelectorAll("[data-kartmax-facet-toggle]").forEach(function (button) {
      button.addEventListener("click", function () {
        const facetKey = button.getAttribute("data-facet-key") || "";
        runtime.expandedFacetKey =
          runtime.expandedFacetKey === facetKey ? "" : facetKey;
        expandFacet(container, runtime.expandedFacetKey);
      });
    });

    filtersNode.querySelectorAll("[data-kartmax-facet-input]").forEach(function (input) {
      input.addEventListener("change", function () {
        const value = input.value || "";
        if (!value) {
          return;
        }

        if (input.checked) {
          if (pending.activeFilters.indexOf(value) === -1) {
            pending.activeFilters.push(value);
          }
        } else {
          pending.activeFilters = pending.activeFilters.filter(function (item) {
            return item !== value;
          });
        }

        syncClearFilterButton(container, pending);

        // Desktop: auto-apply. Mobile: wait for Apply button.
        if (!isMobileFilterViewport()) {
          commitFilters();
        }
      });
    });

    clearButton.onclick = function () {
      pending.activeFilters = [];
      syncClearFilterButton(container, pending);
      commitFilters();
    };

    if (applyButton) {
      applyButton.onclick = function () {
        commitFilters();
      };
    }
  }

  function buildFilterValue(option) {
    const code = option.code || "";
    const value = option.value_key || option.value || "";
    if (!code || !value) {
      return "";
    }

    return code + "~" + value;
  }

  function updateFallbackLink(link, searchPath, query) {
    link.href = buildSearchPageHref(searchPath, query);
  }

  function resolveSearchPageMountTarget(config) {
    const selectorText = normalizeSearchPageMountSelector(
      config.searchPageMountSelector,
    );

    return findFirstMatchingNode(selectorText);
  }

  function mountSearchPageContainer(target, container, position) {
    const normalizedPosition = normalizeInsertPosition(position);

    if (normalizedPosition === "beforebegin" || normalizedPosition === "afterend") {
      target.insertAdjacentElement(normalizedPosition, container);
      return;
    }

    target.insertAdjacentElement(normalizedPosition, container);
  }

  function normalizeInsertPosition(position) {
    if (
      position === "beforebegin" ||
      position === "afterbegin" ||
      position === "beforeend" ||
      position === "afterend"
    ) {
      return position;
    }

    return "afterbegin";
  }

  function findFirstMatchingNode(selectorText) {
    if (!selectorText) {
      return null;
    }

    const selectors = selectorText
      .split(",")
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);

    for (const selector of selectors) {
      const match = document.querySelector(selector);
      if (match) {
        return match;
      }
    }

    return null;
  }

  function isAbsoluteUrl(value) {
    return /^https?:\/\//i.test(value || "");
  }

  // ---------------------------------------------------------------------------
  // search tracking (search_id / session_id) for the
  // plp-special call.
  //
  // Sources, in priority order:
  //   1. IDs passed in the /search URL (stashed in sessionStorage by
  //      stripSearchTrackingFromBrowserUrl), only if they belong to this query.
  //   2. IDs written by the KM search widget to localStorage. search_id is used
  //      only when km-search-widget:current-query-text matches this query, so a
  //      stale id is never attributed to a different search.
  // session_id is session-wide and is not tied to a query.
  // ---------------------------------------------------------------------------
  var SEARCH_TRACKING_QUERY_ID_KEY = "km-search-widget:current-query-id";
  var SEARCH_TRACKING_QUERY_TEXT_KEY = "km-search-widget:current-query-text";
  var SEARCH_TRACKING_SESSION_ID_KEY = "km-search-widget:tracking-session-id";
  var SEARCH_TRACKING_SESSION_STORAGE_KEY = "kartmax:search-page-tracking";

  function readStorage(storage, key) {
    try {
      return String(storage.getItem(key) || "").trim();
    } catch (error) {
      return "";
    }
  }

  function normalizeTrackingQuery(value) {
    const text = String(value || "").trim().toLowerCase();
    return text === "*" ? "" : text;
  }

  function readSearchTrackingParams(query) {
    const currentQuery = normalizeTrackingQuery(query);

    // 1. IDs handed over in the URL (freshest, tied to this navigation)
    let fromUrl = {};
    try {
      fromUrl =
        JSON.parse(
          readStorage(window.sessionStorage, SEARCH_TRACKING_SESSION_STORAGE_KEY) || "{}",
        ) || {};
    } catch (error) {
      fromUrl = {};
    }
    const urlMatchesQuery = normalizeTrackingQuery(fromUrl.query) === currentQuery;

    // 2. IDs written by the KM search widget
    const widgetSearchId = readStorage(window.localStorage, SEARCH_TRACKING_QUERY_ID_KEY);
    const widgetQueryText = readStorage(window.localStorage, SEARCH_TRACKING_QUERY_TEXT_KEY);
    const widgetSessionId = readStorage(window.localStorage, SEARCH_TRACKING_SESSION_ID_KEY);
    const widgetMatchesQuery = normalizeTrackingQuery(widgetQueryText) === currentQuery;

    return {
      searchId:
        (urlMatchesQuery && fromUrl.searchId) ||
        (widgetMatchesQuery && widgetSearchId) ||
        null,
      sessionId: widgetSessionId || fromUrl.sessionId || null,
    };
  }

  // Polls briefly so the KM widget has time to write its ids on /search.
  function waitForSearchTracking(query, timeoutMs) {
    return new Promise(function (resolve) {
      const startedAt = Date.now();
      (function check() {
        const tracking = readSearchTrackingParams(query);
        if (
          (tracking.searchId && tracking.sessionId) ||
          Date.now() - startedAt >= timeoutMs
        ) {
          resolve(tracking);
          return;
        }
        window.setTimeout(check, 100);
      })();
    });
  }

  function appendSearchPageTrackingParams(urlString, tracking) {
    if (!urlString || !isKartmaxSearchPage() || !tracking) {
      return urlString;
    }
    if (!tracking.searchId && !tracking.sessionId) {
      console.log("[KartmaX Search] No tracking ids available for this query.", {
        origin: window.location.origin,
        isTopWindow: window.top === window,
      });
      return urlString;
    }

    const url = isAbsoluteUrl(urlString)
      ? new URL(urlString)
      : new URL(urlString, window.location.origin);

    if (tracking.searchId) {
      url.searchParams.set("search_id", tracking.searchId);
    }
    if (tracking.sessionId) {
      url.searchParams.set("session_id", tracking.sessionId);
    }

    console.log("[KartmaX Search] PLP tracking ids:", tracking);
    console.log("[KartmaX Search] Final API URL:", url.toString());

    return url.toString();
  }

  // tracking params removed from here; they are added
  // only for the search-page (plp-special) call via appendSearchPageTrackingParams.
  function buildSearchUrl(apiUrl, query, limit, state) {
    if (!apiUrl) {
      return null;
    }

    const url = isAbsoluteUrl(apiUrl)
      ? new URL(apiUrl)
      : new URL(apiUrl, window.location.origin);
    const normalizedQuery = (query || "*").trim() || "*";

    url.searchParams.set("query", normalizedQuery);

    url.searchParams.delete("rows");
    url.searchParams.delete("size");

    if (limit) {
      url.searchParams.set("page", String((state && state.page) || 1));
      url.searchParams.set("count", String(limit));
    }

    if (state) {
      const combinedFilter = ["overall_stock_status~in-stock"]
        .concat(combineFiltersForApi(state.activeFilters) || [])
        .filter(Boolean)
        .join("|");
      if (combinedFilter) {
        url.searchParams.set("filter", combinedFilter);
      }

      if (state.sortBy) {
        url.searchParams.set("sort_by", state.sortBy);
        url.searchParams.set("sort_dir", state.sortDir === "asc" ? "asc" : "desc");
      }
    }

    return url.toString();
  }

  function getSearchPagePath() {
    const config = getSearchConfig();
    return (config && config.fallbackSearchPath) || "/search";
  }

  function formatPrice(value) {
    return renderMoneyWithDirham(value);
  }

  function buildSearchPageHref(searchPath, query) {
    const params = new URLSearchParams();
    if (query && query !== "*") {
      params.set("q", query);
    }

    return params.toString() ? searchPath + "?" + params.toString() : searchPath;
  }

  function navigateToSearchPage(config, query) {
    if (!config || !config.fallbackSearchPath) {
      return;
    }

    window.location.href = buildSearchPageHref(config.fallbackSearchPath, query);
  }

  function getSearchConfig() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root) {
      return null;
    }

    const configNode = root.querySelector("[data-kartmax-km-search-config]");
    return configNode && configNode.textContent
      ? normalizeConfig(JSON.parse(configNode.textContent))
      : null;
  }

  function escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#39;");
  }

  function escapeAttribute(value) {
    return escapeHtml(value);
  }
})();